var items = {
  "block.minecraft.acacia_button": "Akazijeholzknopp",
  "block.minecraft.acacia_door": "Akazijeholzdür",
  "block.minecraft.acacia_fence": "Akazijeholzzong",
  "block.minecraft.acacia_fence_gate": "Akazijeholzjadder",
  "block.minecraft.acacia_hanging_sign": "Akazienholzhängeschild",
  "block.minecraft.acacia_leaves": "Akazijelauv",
  "block.minecraft.acacia_log": "Akazijestamm",
  "block.minecraft.acacia_planks": "Akazijeholzbredder",
  "block.minecraft.acacia_pressure_plate": "Akazijeholzdröckplaat",
  "block.minecraft.acacia_sapling": "Akazijeböumche",
  "block.minecraft.acacia_shelf": "Akazienholzregal",
  "block.minecraft.acacia_sign": "Akazijeholzscheld",
  "block.minecraft.acacia_slab": "Akazijeholzstof",
  "block.minecraft.acacia_stairs": "Akazijeholztrapp",
  "block.minecraft.acacia_trapdoor": "Akazijeholztrappdür",
  "block.minecraft.acacia_wall_hanging_sign": "Akazienholzwandhängeschild",
  "block.minecraft.acacia_wall_sign": "Akazijeholzwandscheld",
  "block.minecraft.acacia_wood": "Akazijeholz",
  "block.minecraft.activator_rail": "Aktiveerongsschinne",
  "block.minecraft.air": "Luff",
  "block.minecraft.allium": "Öllisch",
  "block.minecraft.amethyst_block": "Ametüstblock",
  "block.minecraft.amethyst_cluster": "Ametüsthaufe",
  "block.minecraft.ancient_debris": "Ahle Schrott",
  "block.minecraft.andesite": "Andesit",
  "block.minecraft.andesite_slab": "Andesitstof",
  "block.minecraft.andesite_stairs": "Andesittrapp",
  "block.minecraft.andesite_wall": "Andesitmor",
  "block.minecraft.anvil": "Amboß",
  "block.minecraft.attached_melon_stem": "Drüjje Melonerank",
  "block.minecraft.attached_pumpkin_stem": "Drüjje Kürbisrank",
  "block.minecraft.azalea": "Azalee",
  "block.minecraft.azalea_leaves": "Azaleelauv",
  "block.minecraft.azure_bluet": "Postelingstähnche",
  "block.minecraft.bamboo": "Bambus",
  "block.minecraft.bamboo_block": "Bambusblock",
  "block.minecraft.bamboo_button": "Bambusknopf",
  "block.minecraft.bamboo_door": "Bambustür",
  "block.minecraft.bamboo_fence": "Bambuszaun",
  "block.minecraft.bamboo_fence_gate": "Bambuszauntor",
  "block.minecraft.bamboo_hanging_sign": "Bambushängeschild",
  "block.minecraft.bamboo_mosaic": "Bambusmosaik",
  "block.minecraft.bamboo_mosaic_slab": "Bambusmosaikstufe",
  "block.minecraft.bamboo_mosaic_stairs": "Bambusmosaiktreppe",
  "block.minecraft.bamboo_planks": "Bambusbretter",
  "block.minecraft.bamboo_pressure_plate": "Bambusdruckplatte",
  "block.minecraft.bamboo_sapling": "Bambusspross",
  "block.minecraft.bamboo_shelf": "Bambusregal",
  "block.minecraft.bamboo_sign": "Bambusschild",
  "block.minecraft.bamboo_slab": "Bambusstufe",
  "block.minecraft.bamboo_stairs": "Bambustreppe",
  "block.minecraft.bamboo_trapdoor": "Bambusfalltür",
  "block.minecraft.bamboo_wall_hanging_sign": "Bambuswandhängeschild",
  "block.minecraft.bamboo_wall_sign": "Bambuswandschild",
  "block.minecraft.banner.base.black": "Ratzekal schwatz Feld",
  "block.minecraft.banner.base.blue": "Ratzekal blau Feld",
  "block.minecraft.banner.base.brown": "Ratzekal brung Feld",
  "block.minecraft.banner.base.cyan": "Ratzekal blaujrön Feld",
  "block.minecraft.banner.base.gray": "Ratzekal jrau Feld",
  "block.minecraft.banner.base.green": "Ratzekal jrön Feld",
  "block.minecraft.banner.base.light_blue": "Ratzekal hellblau Feld",
  "block.minecraft.banner.base.light_gray": "Ratzekal helljrau Feld",
  "block.minecraft.banner.base.lime": "Ratzekal helljrön Feld",
  "block.minecraft.banner.base.magenta": "Ratzekal majenta Feld",
  "block.minecraft.banner.base.orange": "Ratzekal orangsch Feld",
  "block.minecraft.banner.base.pink": "Ratzekal rusa Feld",
  "block.minecraft.banner.base.purple": "Ratzekal vijelett Feld",
  "block.minecraft.banner.base.red": "Ratzekal rut Feld",
  "block.minecraft.banner.base.white": "Ratzekal wieß Feld",
  "block.minecraft.banner.base.yellow": "Ratzekal jäl Feld",
  "block.minecraft.banner.border.black": "Schwatze Bod",
  "block.minecraft.banner.border.blue": "Blaue Bod",
  "block.minecraft.banner.border.brown": "Brunge Bod",
  "block.minecraft.banner.border.cyan": "Blaujröne Bod",
  "block.minecraft.banner.border.gray": "Jraue Bod",
  "block.minecraft.banner.border.green": "Jröne Bod",
  "block.minecraft.banner.border.light_blue": "Hellblaue Bod",
  "block.minecraft.banner.border.light_gray": "Helljraue Bod",
  "block.minecraft.banner.border.lime": "Helljröne Bod",
  "block.minecraft.banner.border.magenta": "Majenta Bod",
  "block.minecraft.banner.border.orange": "Orangsche Bod",
  "block.minecraft.banner.border.pink": "Rusa Bod",
  "block.minecraft.banner.border.purple": "Vijelette Bod",
  "block.minecraft.banner.border.red": "Rude Bod",
  "block.minecraft.banner.border.white": "Wieße Bod",
  "block.minecraft.banner.border.yellow": "Jäle Bod",
  "block.minecraft.banner.bricks.black": "Feld schwatz jemort",
  "block.minecraft.banner.bricks.blue": "Feld blau jemort",
  "block.minecraft.banner.bricks.brown": "Feld brung jemort",
  "block.minecraft.banner.bricks.cyan": "Feld blaujrön jemort",
  "block.minecraft.banner.bricks.gray": "Feld jrau jemort",
  "block.minecraft.banner.bricks.green": "Feld jrön jemort",
  "block.minecraft.banner.bricks.light_blue": "Feld hellblau jemort",
  "block.minecraft.banner.bricks.light_gray": "Feld helljrau jemort",
  "block.minecraft.banner.bricks.lime": "Feld helljrön jemort",
  "block.minecraft.banner.bricks.magenta": "Feld majenta jemort",
  "block.minecraft.banner.bricks.orange": "Feld orangsch jemort",
  "block.minecraft.banner.bricks.pink": "Feld rusa jemort",
  "block.minecraft.banner.bricks.purple": "Feld vijelett jemort",
  "block.minecraft.banner.bricks.red": "Feld rut jemort",
  "block.minecraft.banner.bricks.white": "Feld wieß jemort",
  "block.minecraft.banner.bricks.yellow": "Feld jäl jemort",
  "block.minecraft.banner.circle.black": "Schwatze Ball",
  "block.minecraft.banner.circle.blue": "Blaue Ball",
  "block.minecraft.banner.circle.brown": "Brunge Ball",
  "block.minecraft.banner.circle.cyan": "Blaujröne Ball",
  "block.minecraft.banner.circle.gray": "Jraue Ball",
  "block.minecraft.banner.circle.green": "Jröne Ball",
  "block.minecraft.banner.circle.light_blue": "Hellblaue Ball",
  "block.minecraft.banner.circle.light_gray": "Helljraue Ball",
  "block.minecraft.banner.circle.lime": "Helljröne Ball",
  "block.minecraft.banner.circle.magenta": "Majenta Ball",
  "block.minecraft.banner.circle.orange": "Orangsche Ball",
  "block.minecraft.banner.circle.pink": "Rusa Ball",
  "block.minecraft.banner.circle.purple": "Vijelette Ball",
  "block.minecraft.banner.circle.red": "Rude Ball",
  "block.minecraft.banner.circle.white": "Wieße Ball",
  "block.minecraft.banner.circle.yellow": "Jäle Ball",
  "block.minecraft.banner.creeper.black": "Schwatze Creeper",
  "block.minecraft.banner.creeper.blue": "Blaue Creeper",
  "block.minecraft.banner.creeper.brown": "Brunge Creeper",
  "block.minecraft.banner.creeper.cyan": "Blaujröne Creeper",
  "block.minecraft.banner.creeper.gray": "Jraue Creeper",
  "block.minecraft.banner.creeper.green": "Jröne Creeper",
  "block.minecraft.banner.creeper.light_blue": "Hellblaue Creeper",
  "block.minecraft.banner.creeper.light_gray": "Helljraue Creeper",
  "block.minecraft.banner.creeper.lime": "Helljröne Creeper",
  "block.minecraft.banner.creeper.magenta": "Majenta Creeper",
  "block.minecraft.banner.creeper.orange": "Orangsche Creeper",
  "block.minecraft.banner.creeper.pink": "Rusa Creeper",
  "block.minecraft.banner.creeper.purple": "Vijelette Creeper",
  "block.minecraft.banner.creeper.red": "Rude Creeper",
  "block.minecraft.banner.creeper.white": "Wieße Creeper",
  "block.minecraft.banner.creeper.yellow": "Jäle Creeper",
  "block.minecraft.banner.cross.black": "Schwatze Andreaskrütz",
  "block.minecraft.banner.cross.blue": "Blaue Andreaskrütz",
  "block.minecraft.banner.cross.brown": "Brunge Andreaskrütz",
  "block.minecraft.banner.cross.cyan": "Blaujröne Andreaskrütz",
  "block.minecraft.banner.cross.gray": "Jraue Andreaskrütz",
  "block.minecraft.banner.cross.green": "Jröne Andreaskrütz",
  "block.minecraft.banner.cross.light_blue": "Hellblau Andreaskrütz",
  "block.minecraft.banner.cross.light_gray": "Helljraue Andreaskrütz",
  "block.minecraft.banner.cross.lime": "Helljrön Andreaskrütz",
  "block.minecraft.banner.cross.magenta": "Majenta Andreaskrütz",
  "block.minecraft.banner.cross.orange": "Orangsche Andreaskrütz",
  "block.minecraft.banner.cross.pink": "Rusa Andreaskrütz",
  "block.minecraft.banner.cross.purple": "Vijelette Andreaskrütz",
  "block.minecraft.banner.cross.red": "Rude Andreaskrütz",
  "block.minecraft.banner.cross.white": "Wieße Andreaskrütz",
  "block.minecraft.banner.cross.yellow": "Jäl Andreaskrütz",
  "block.minecraft.banner.curly_border.black": "Schwatze enjedötsche Bod",
  "block.minecraft.banner.curly_border.blue": "Blaue enjedötsche Bod",
  "block.minecraft.banner.curly_border.brown": "Brunge enjedötsche Bod",
  "block.minecraft.banner.curly_border.cyan": "Blaujröne enjedötsche Bod",
  "block.minecraft.banner.curly_border.gray": "Jraue enjedötsche Bod",
  "block.minecraft.banner.curly_border.green": "Jröne enjedötsche Bod",
  "block.minecraft.banner.curly_border.light_blue": "Hellblaue enjedötsche Bod",
  "block.minecraft.banner.curly_border.light_gray": "Helljraue enjedötsche Bod",
  "block.minecraft.banner.curly_border.lime": "Helljröne enjedötsche Bod",
  "block.minecraft.banner.curly_border.magenta": "Majenta enjedötsche Bod",
  "block.minecraft.banner.curly_border.orange": "Orangsche enjedötsche Bod",
  "block.minecraft.banner.curly_border.pink": "Rusa enjedötsche Bod",
  "block.minecraft.banner.curly_border.purple": "Vijelette enjedötsche Bod",
  "block.minecraft.banner.curly_border.red": "Rude enjedötsche Bod",
  "block.minecraft.banner.curly_border.white": "Wieße enjedötsche Bod",
  "block.minecraft.banner.curly_border.yellow": "Jäle enjedötsche Bod",
  "block.minecraft.banner.diagonal_left.black": "Schwatz schällinks jedeilt",
  "block.minecraft.banner.diagonal_left.blue": "Blau schällinks jedeilt",
  "block.minecraft.banner.diagonal_left.brown": "Brung schällinks jedeilt",
  "block.minecraft.banner.diagonal_left.cyan": "Blaujrön schällinks jedeilt",
  "block.minecraft.banner.diagonal_left.gray": "Jrau schällinks jedeilt",
  "block.minecraft.banner.diagonal_left.green": "Jrön schällinks jedeilt",
  "block.minecraft.banner.diagonal_left.light_blue": "Hellblau schällinks jedeilt",
  "block.minecraft.banner.diagonal_left.light_gray": "Helljrau schällinks jedeilt",
  "block.minecraft.banner.diagonal_left.lime": "Helljrön schällinks jedeilt",
  "block.minecraft.banner.diagonal_left.magenta": "Majenta schällinks jedeilt",
  "block.minecraft.banner.diagonal_left.orange": "Orangsch schällinks jedeilt",
  "block.minecraft.banner.diagonal_left.pink": "Rusa schällinks jedeilt",
  "block.minecraft.banner.diagonal_left.purple": "Vijelett schällinks jedeilt",
  "block.minecraft.banner.diagonal_left.red": "Rut schällinks jedeilt",
  "block.minecraft.banner.diagonal_left.white": "Wieß schällinks jedeilt",
  "block.minecraft.banner.diagonal_left.yellow": "Jäl schällinks jedeilt",
  "block.minecraft.banner.diagonal_right.black": "Schwatz schälrächs jedeilt",
  "block.minecraft.banner.diagonal_right.blue": "Blau schälrächs jedeilt",
  "block.minecraft.banner.diagonal_right.brown": "Brung schälrächs jedeilt",
  "block.minecraft.banner.diagonal_right.cyan": "Blaujrön schälrächs jedeilt",
  "block.minecraft.banner.diagonal_right.gray": "Jrau schälrächs jedeilt",
  "block.minecraft.banner.diagonal_right.green": "Jrön schälrächs jedeilt",
  "block.minecraft.banner.diagonal_right.light_blue": "Hellblau schälrächs jedeilt",
  "block.minecraft.banner.diagonal_right.light_gray": "Helljrau schälrächs jedeilt",
  "block.minecraft.banner.diagonal_right.lime": "Helljrön schälrächs jedeilt",
  "block.minecraft.banner.diagonal_right.magenta": "Majenta schälrächs jedeilt",
  "block.minecraft.banner.diagonal_right.orange": "Orangsch schälrächs jedeilt",
  "block.minecraft.banner.diagonal_right.pink": "Rusa schälrächs jedeilt",
  "block.minecraft.banner.diagonal_right.purple": "Vijelett schälrächs jedeilt",
  "block.minecraft.banner.diagonal_right.red": "Rut schälrächs jedeilt",
  "block.minecraft.banner.diagonal_right.white": "Wieß schälrächs jedeilt",
  "block.minecraft.banner.diagonal_right.yellow": "Jäl schälrächs jedeilt",
  "block.minecraft.banner.diagonal_up_left.black": "Schwatz schälrächs jedeilt (angerseröm)",
  "block.minecraft.banner.diagonal_up_left.blue": "Blau schälrächs jedeilt (angerseröm)",
  "block.minecraft.banner.diagonal_up_left.brown": "Brung schälrächs jedeilt (angerseröm)",
  "block.minecraft.banner.diagonal_up_left.cyan": "Blaujrön schälrächs jedeilt (angerseröm)",
  "block.minecraft.banner.diagonal_up_left.gray": "Jrau schälrächs jedeilt (angerseröm)",
  "block.minecraft.banner.diagonal_up_left.green": "Jrön schälrächs jedeilt (angerseröm)",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Hellblau schälrächs jedeilt (angerseröm)",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Helljrau schälrächs jedeilt (angerseröm)",
  "block.minecraft.banner.diagonal_up_left.lime": "Helljrön schälrächs jedeilt (angerseröm)",
  "block.minecraft.banner.diagonal_up_left.magenta": "Majenta schälrächs jedeilt (angerseröm)",
  "block.minecraft.banner.diagonal_up_left.orange": "Orangsch schälrächs jedeilt (angerseröm)",
  "block.minecraft.banner.diagonal_up_left.pink": "Rusa schälrächs jedeilt (angerseröm)",
  "block.minecraft.banner.diagonal_up_left.purple": "Vijelett schälrächs jedeilt (angerseröm)",
  "block.minecraft.banner.diagonal_up_left.red": "Rut schälrächs jedeilt (angerseröm)",
  "block.minecraft.banner.diagonal_up_left.white": "Wieß schälrächs jedeilt (angerseröm)",
  "block.minecraft.banner.diagonal_up_left.yellow": "Jäl schälrächs jedeilt (angerseröm)",
  "block.minecraft.banner.diagonal_up_right.black": "Schwatz schällinks jedeilt (angerseröm)",
  "block.minecraft.banner.diagonal_up_right.blue": "Blau schällinks jedeilt (angerseröm)",
  "block.minecraft.banner.diagonal_up_right.brown": "Brung schällinks jedeilt (angerseröm)",
  "block.minecraft.banner.diagonal_up_right.cyan": "Blaujrön schällinks jedeilt (angerseröm)",
  "block.minecraft.banner.diagonal_up_right.gray": "Jrau schällinks jedeilt (angerseröm)",
  "block.minecraft.banner.diagonal_up_right.green": "Jrön schällinks jedeilt (angerseröm)",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Hellblau schällinks jedeilt (angerseröm)",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Helljrau schällinks jedeilt (angerseröm)",
  "block.minecraft.banner.diagonal_up_right.lime": "Helljrön schällinks jedeilt (angerseröm)",
  "block.minecraft.banner.diagonal_up_right.magenta": "Majenta schällinks jedeilt (angerseröm)",
  "block.minecraft.banner.diagonal_up_right.orange": "Orangsch schällinks jedeilt (angerseröm)",
  "block.minecraft.banner.diagonal_up_right.pink": "Rusa schällinks jedeilt (angerseröm)",
  "block.minecraft.banner.diagonal_up_right.purple": "Vijelett schällinks jedeilt (angerseröm)",
  "block.minecraft.banner.diagonal_up_right.red": "Rut schällinks jedeilt (angerseröm)",
  "block.minecraft.banner.diagonal_up_right.white": "Wieß schällinks jedeilt (angerseröm)",
  "block.minecraft.banner.diagonal_up_right.yellow": "Jäl schällinks jedeilt (angerseröm)",
  "block.minecraft.banner.flow.black": "Schwarzer Fluss",
  "block.minecraft.banner.flow.blue": "Blauer Fluss",
  "block.minecraft.banner.flow.brown": "Brauner Fluss",
  "block.minecraft.banner.flow.cyan": "Türkiser Fluss",
  "block.minecraft.banner.flow.gray": "Grauer Fluss",
  "block.minecraft.banner.flow.green": "Grüner Fluss",
  "block.minecraft.banner.flow.light_blue": "Hellblauer Fluss",
  "block.minecraft.banner.flow.light_gray": "Hellgrauer Fluss",
  "block.minecraft.banner.flow.lime": "Hellgrüner Fluss",
  "block.minecraft.banner.flow.magenta": "Magenta Fluss",
  "block.minecraft.banner.flow.orange": "Oranger Fluss",
  "block.minecraft.banner.flow.pink": "Rosa Fluss",
  "block.minecraft.banner.flow.purple": "Violetter Fluss",
  "block.minecraft.banner.flow.red": "Roter Fluss",
  "block.minecraft.banner.flow.white": "Weißer Fluss",
  "block.minecraft.banner.flow.yellow": "Gelber Fluss",
  "block.minecraft.banner.flower.black": "Schwatz Blom",
  "block.minecraft.banner.flower.blue": "Blau Blom",
  "block.minecraft.banner.flower.brown": "Brung Blom",
  "block.minecraft.banner.flower.cyan": "Blaujrön Blom",
  "block.minecraft.banner.flower.gray": "Jrau Blom",
  "block.minecraft.banner.flower.green": "Jrön Blom",
  "block.minecraft.banner.flower.light_blue": "Hellblau Blom",
  "block.minecraft.banner.flower.light_gray": "Helljrau Blom",
  "block.minecraft.banner.flower.lime": "Helljrön Blom",
  "block.minecraft.banner.flower.magenta": "Majenta Blom",
  "block.minecraft.banner.flower.orange": "Orangsch Blom",
  "block.minecraft.banner.flower.pink": "Rusa Blom",
  "block.minecraft.banner.flower.purple": "Vijelette Blom",
  "block.minecraft.banner.flower.red": "Rut Blom",
  "block.minecraft.banner.flower.white": "Wieß Blom",
  "block.minecraft.banner.flower.yellow": "Jäl Blom",
  "block.minecraft.banner.globe.black": "Schwatze Jlobus",
  "block.minecraft.banner.globe.blue": "Blaue Jlobus",
  "block.minecraft.banner.globe.brown": "Brunge Jlobus",
  "block.minecraft.banner.globe.cyan": "Blaujröne Jlobus",
  "block.minecraft.banner.globe.gray": "Jraue Jlobus",
  "block.minecraft.banner.globe.green": "Jröne Jlobus",
  "block.minecraft.banner.globe.light_blue": "Hellblaue Jlobus",
  "block.minecraft.banner.globe.light_gray": "Helljraue Jlobus",
  "block.minecraft.banner.globe.lime": "Helljröne Jlobus",
  "block.minecraft.banner.globe.magenta": "Majenta Jlobus",
  "block.minecraft.banner.globe.orange": "Orangsche Jlobus",
  "block.minecraft.banner.globe.pink": "Rusa Jlobus",
  "block.minecraft.banner.globe.purple": "Vijelette Jlobus",
  "block.minecraft.banner.globe.red": "Rude Jlobus",
  "block.minecraft.banner.globe.white": "Wieße Jlobus",
  "block.minecraft.banner.globe.yellow": "Jäle Jlobus",
  "block.minecraft.banner.gradient.black": "Schwatze Färvverlauf",
  "block.minecraft.banner.gradient.blue": "Blaue Färvverlauf",
  "block.minecraft.banner.gradient.brown": "Brunge Färvverlauf",
  "block.minecraft.banner.gradient.cyan": "Blaujröne Färvverlauf",
  "block.minecraft.banner.gradient.gray": "Jraue Färvverlauf",
  "block.minecraft.banner.gradient.green": "Jröne Färvverlauf",
  "block.minecraft.banner.gradient.light_blue": "Hellblaue Färvverlauf",
  "block.minecraft.banner.gradient.light_gray": "Helljraue Färvverlauf",
  "block.minecraft.banner.gradient.lime": "Helljröne Färvverlauf",
  "block.minecraft.banner.gradient.magenta": "Majenta Färvverlauf",
  "block.minecraft.banner.gradient.orange": "Orangsche Färvverlauf",
  "block.minecraft.banner.gradient.pink": "Rusa Färvverlauf",
  "block.minecraft.banner.gradient.purple": "Vijelette Färvverlauf",
  "block.minecraft.banner.gradient.red": "Rude Färvverlauf",
  "block.minecraft.banner.gradient.white": "Wieße Färvverlauf",
  "block.minecraft.banner.gradient.yellow": "Jäle Färvverlauf",
  "block.minecraft.banner.gradient_up.black": "Schwatze Färvverlauf vun unge",
  "block.minecraft.banner.gradient_up.blue": "Blaue Färvverlauf vun unge",
  "block.minecraft.banner.gradient_up.brown": "Brunge Färvverlauf vun unge",
  "block.minecraft.banner.gradient_up.cyan": "Blaujröne Färvverlauf vun unge",
  "block.minecraft.banner.gradient_up.gray": "Jraue Färvverlauf vun unge",
  "block.minecraft.banner.gradient_up.green": "Jröne Färvverlauf vun unge",
  "block.minecraft.banner.gradient_up.light_blue": "Hellblaue Färvverlauf vun unge",
  "block.minecraft.banner.gradient_up.light_gray": "Helljraue Färvverlauf vun unge",
  "block.minecraft.banner.gradient_up.lime": "Helljröne Färvverlauf vun unge",
  "block.minecraft.banner.gradient_up.magenta": "Majenta Färvverlauf vun unge",
  "block.minecraft.banner.gradient_up.orange": "Orangsche Färvverlauf vun unge",
  "block.minecraft.banner.gradient_up.pink": "Rusa Färvverlauf vun unge",
  "block.minecraft.banner.gradient_up.purple": "Vijelette Färvverlauf vun unge",
  "block.minecraft.banner.gradient_up.red": "Rude Färvverlauf vun unge",
  "block.minecraft.banner.gradient_up.white": "Wieße Färvverlauf vun unge",
  "block.minecraft.banner.gradient_up.yellow": "Jäle Färvverlauf vun unge",
  "block.minecraft.banner.guster.black": "Schwarzer Windstoßer",
  "block.minecraft.banner.guster.blue": "Blauer Windstoßer",
  "block.minecraft.banner.guster.brown": "Brauner Windstoßer",
  "block.minecraft.banner.guster.cyan": "Türkiser Windstoßer",
  "block.minecraft.banner.guster.gray": "Grauer Windstoßer",
  "block.minecraft.banner.guster.green": "Grüner Windstoßer",
  "block.minecraft.banner.guster.light_blue": "Hellblauer Windstoßer",
  "block.minecraft.banner.guster.light_gray": "Hellgrauer Windstoßer",
  "block.minecraft.banner.guster.lime": "Hellgrüner Windstoßer",
  "block.minecraft.banner.guster.magenta": "Magenta Windstoßer",
  "block.minecraft.banner.guster.orange": "Oranger Windstoßer",
  "block.minecraft.banner.guster.pink": "Rosa Windstoßer",
  "block.minecraft.banner.guster.purple": "Violetter Windstoßer",
  "block.minecraft.banner.guster.red": "Roter Windstoßer",
  "block.minecraft.banner.guster.white": "Weißer Windstoßer",
  "block.minecraft.banner.guster.yellow": "Gelber Windstoßer",
  "block.minecraft.banner.half_horizontal.black": "Bovven rut jedeilt",
  "block.minecraft.banner.half_horizontal.blue": "Bovven blau jedeilt",
  "block.minecraft.banner.half_horizontal.brown": "Bovven brung jedeilt",
  "block.minecraft.banner.half_horizontal.cyan": "Bovven blaujrön jedeilt",
  "block.minecraft.banner.half_horizontal.gray": "Bovven jrau jedeilt",
  "block.minecraft.banner.half_horizontal.green": "Bovven jrön jedeilt",
  "block.minecraft.banner.half_horizontal.light_blue": "Bovven hellblau jedeilt",
  "block.minecraft.banner.half_horizontal.light_gray": "Bovven helljrau jedeilt",
  "block.minecraft.banner.half_horizontal.lime": "Bovven helljrön jedeilt",
  "block.minecraft.banner.half_horizontal.magenta": "Bovven majenta jedeilt",
  "block.minecraft.banner.half_horizontal.orange": "Bovven orangsch jedeilt",
  "block.minecraft.banner.half_horizontal.pink": "Bovven rusa jedeilt",
  "block.minecraft.banner.half_horizontal.purple": "Bovven vijelett jedeilt",
  "block.minecraft.banner.half_horizontal.red": "Bovven rut jedeilt",
  "block.minecraft.banner.half_horizontal.white": "Bovven wieß jedeilt",
  "block.minecraft.banner.half_horizontal.yellow": "Bovven jäl jedeilt",
  "block.minecraft.banner.half_horizontal_bottom.black": "Unge schwatz jedeilt",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Unge blau jedeilt",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Unge brung jedeilt",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Unge blaujrön jedeilt",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Unge jrau jedeilt",
  "block.minecraft.banner.half_horizontal_bottom.green": "Unge jrön jedeilt",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Unge hellblau jedeilt",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Unge helljrau jedeilt",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Unge helljrön jedeilt",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Unge majenta jedeilt",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Unge orangsch jedeilt",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Unge rusa jedeilt",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Unge vijelett jedeilt",
  "block.minecraft.banner.half_horizontal_bottom.red": "Unge rut jedeilt",
  "block.minecraft.banner.half_horizontal_bottom.white": "Unge wieß jedeilt",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Unge jäl jedeilt",
  "block.minecraft.banner.half_vertical.black": "Rächs schwatz jespalde",
  "block.minecraft.banner.half_vertical.blue": "Rächs blau jespalde",
  "block.minecraft.banner.half_vertical.brown": "Rächs brung jespalde",
  "block.minecraft.banner.half_vertical.cyan": "Rächs blaujrön jespalde",
  "block.minecraft.banner.half_vertical.gray": "Rächs jrau jespalde",
  "block.minecraft.banner.half_vertical.green": "Rächs jrön jespalde",
  "block.minecraft.banner.half_vertical.light_blue": "Rächs hellblau jespalde",
  "block.minecraft.banner.half_vertical.light_gray": "Rächs helljrau jespalde",
  "block.minecraft.banner.half_vertical.lime": "Rächs helljrön jespalde",
  "block.minecraft.banner.half_vertical.magenta": "Rächs majenta jespalde",
  "block.minecraft.banner.half_vertical.orange": "Rächs orangsch jespalde",
  "block.minecraft.banner.half_vertical.pink": "Rächs rusa jespalde",
  "block.minecraft.banner.half_vertical.purple": "Rächs vijelett jespalde",
  "block.minecraft.banner.half_vertical.red": "Rächs rut jespalde",
  "block.minecraft.banner.half_vertical.white": "Rächs wieß jespalde",
  "block.minecraft.banner.half_vertical.yellow": "Rächs jäl jespalde",
  "block.minecraft.banner.half_vertical_right.black": "Links schwatz jespalde",
  "block.minecraft.banner.half_vertical_right.blue": "Links blau jespalde",
  "block.minecraft.banner.half_vertical_right.brown": "Links brung jespalde",
  "block.minecraft.banner.half_vertical_right.cyan": "Links blaujrön jespalde",
  "block.minecraft.banner.half_vertical_right.gray": "Links jrau jespalde",
  "block.minecraft.banner.half_vertical_right.green": "Links jrön jespalde",
  "block.minecraft.banner.half_vertical_right.light_blue": "Links hellblau jespalde",
  "block.minecraft.banner.half_vertical_right.light_gray": "Links helljrau jespalde",
  "block.minecraft.banner.half_vertical_right.lime": "Links helljrön jespalde",
  "block.minecraft.banner.half_vertical_right.magenta": "Links majenta jespalde",
  "block.minecraft.banner.half_vertical_right.orange": "Links orangsch jespalde",
  "block.minecraft.banner.half_vertical_right.pink": "Links rusa jespalde",
  "block.minecraft.banner.half_vertical_right.purple": "Links vijelett jespalde",
  "block.minecraft.banner.half_vertical_right.red": "Links rut jespalde",
  "block.minecraft.banner.half_vertical_right.white": "Links wieß jespalde",
  "block.minecraft.banner.half_vertical_right.yellow": "Links jäl jespalde",
  "block.minecraft.banner.mojang.black": "Schwatze Mojang-Wappe",
  "block.minecraft.banner.mojang.blue": "Blaue Mojang-Wappe",
  "block.minecraft.banner.mojang.brown": "Brunge Mojang-Wappe",
  "block.minecraft.banner.mojang.cyan": "Blaujröne Mojang-Wappe",
  "block.minecraft.banner.mojang.gray": "Jraue Mojang-Wappe",
  "block.minecraft.banner.mojang.green": "Jröne Mojang-Wappe",
  "block.minecraft.banner.mojang.light_blue": "Hellblaue Mojang-Wappe",
  "block.minecraft.banner.mojang.light_gray": "Helljraue Mojang-Wappe",
  "block.minecraft.banner.mojang.lime": "Helljröne Mojang-Wappe",
  "block.minecraft.banner.mojang.magenta": "Majenta Mojang-Wappe",
  "block.minecraft.banner.mojang.orange": "Orangsche Mojang-Wappe",
  "block.minecraft.banner.mojang.pink": "Rusa Mojang-Wappe",
  "block.minecraft.banner.mojang.purple": "Vijelette Mojang-Wappe",
  "block.minecraft.banner.mojang.red": "Rude Mojang-Wappe",
  "block.minecraft.banner.mojang.white": "Wieße Mojang-Wappe",
  "block.minecraft.banner.mojang.yellow": "Jäle Mojang-Wappe",
  "block.minecraft.banner.piglin.black": "Schwatze Schnüß",
  "block.minecraft.banner.piglin.blue": "Blau Schnüß",
  "block.minecraft.banner.piglin.brown": "Brung Schnüß",
  "block.minecraft.banner.piglin.cyan": "Blaujrön Schnüß",
  "block.minecraft.banner.piglin.gray": "Jrau Schnüß",
  "block.minecraft.banner.piglin.green": "Jrön Schnüß",
  "block.minecraft.banner.piglin.light_blue": "Hellblau Schnüß",
  "block.minecraft.banner.piglin.light_gray": "Helljrau Schnüß",
  "block.minecraft.banner.piglin.lime": "Helljrön Schnüß",
  "block.minecraft.banner.piglin.magenta": "Majenta Schnüß",
  "block.minecraft.banner.piglin.orange": "Orangsch Schnüß",
  "block.minecraft.banner.piglin.pink": "Rusa Schnüß",
  "block.minecraft.banner.piglin.purple": "Vijelett Schnüß",
  "block.minecraft.banner.piglin.red": "Rude Schnüß",
  "block.minecraft.banner.piglin.white": "Wieße Schnüß",
  "block.minecraft.banner.piglin.yellow": "Jäl Schnüß",
  "block.minecraft.banner.rhombus.black": "Schwatze Raut",
  "block.minecraft.banner.rhombus.blue": "Blaue Raut",
  "block.minecraft.banner.rhombus.brown": "Brunge Raut",
  "block.minecraft.banner.rhombus.cyan": "Blaujröne Raut",
  "block.minecraft.banner.rhombus.gray": "Jraue Raut",
  "block.minecraft.banner.rhombus.green": "Jröne Raut",
  "block.minecraft.banner.rhombus.light_blue": "Hellblaue Raut",
  "block.minecraft.banner.rhombus.light_gray": "Helljraue Raut",
  "block.minecraft.banner.rhombus.lime": "Helljröne Raut",
  "block.minecraft.banner.rhombus.magenta": "Majenta Raut",
  "block.minecraft.banner.rhombus.orange": "Orangsche Raut",
  "block.minecraft.banner.rhombus.pink": "Rusa Raut",
  "block.minecraft.banner.rhombus.purple": "Vijelette Raut",
  "block.minecraft.banner.rhombus.red": "Rude Raut",
  "block.minecraft.banner.rhombus.white": "Wieße Raut",
  "block.minecraft.banner.rhombus.yellow": "Jäle Raut",
  "block.minecraft.banner.skull.black": "Schwatze Dudekopp",
  "block.minecraft.banner.skull.blue": "Blaue Dudekopp",
  "block.minecraft.banner.skull.brown": "Brunge Dudekopp",
  "block.minecraft.banner.skull.cyan": "Blaujröne Dudekopp",
  "block.minecraft.banner.skull.gray": "Jraue Dudekopp",
  "block.minecraft.banner.skull.green": "Jröne Dudekopp",
  "block.minecraft.banner.skull.light_blue": "Hellblaue Dudekopp",
  "block.minecraft.banner.skull.light_gray": "Helljraue Dudekopp",
  "block.minecraft.banner.skull.lime": "Helljröne Dudekopp",
  "block.minecraft.banner.skull.magenta": "Majenta Dudekopp",
  "block.minecraft.banner.skull.orange": "Orangsch Dudekopp",
  "block.minecraft.banner.skull.pink": "Rusa Dudekopp",
  "block.minecraft.banner.skull.purple": "Vijelett Dudekopp",
  "block.minecraft.banner.skull.red": "Rude Dudekopp",
  "block.minecraft.banner.skull.white": "Wieße Dudekopp",
  "block.minecraft.banner.skull.yellow": "Jäle Dudekopp",
  "block.minecraft.banner.small_stripes.black": "Veer schwatze Pöl",
  "block.minecraft.banner.small_stripes.blue": "Veer blaue Pöl",
  "block.minecraft.banner.small_stripes.brown": "Veer brunge Pöl",
  "block.minecraft.banner.small_stripes.cyan": "Veer blaujröne Pöl",
  "block.minecraft.banner.small_stripes.gray": "Veer jraue Pöl",
  "block.minecraft.banner.small_stripes.green": "Veer jröne Pöl",
  "block.minecraft.banner.small_stripes.light_blue": "Veer hellblaue Pöl",
  "block.minecraft.banner.small_stripes.light_gray": "Veer helljraue Pöl",
  "block.minecraft.banner.small_stripes.lime": "Veer helljröne Pöl",
  "block.minecraft.banner.small_stripes.magenta": "Veer majenta Pöl",
  "block.minecraft.banner.small_stripes.orange": "Veer orangsche Pöl",
  "block.minecraft.banner.small_stripes.pink": "Veer rusa Pöl",
  "block.minecraft.banner.small_stripes.purple": "Veer vijelette Pöl",
  "block.minecraft.banner.small_stripes.red": "Veer rude Pöl",
  "block.minecraft.banner.small_stripes.white": "Veer wieße Pöl",
  "block.minecraft.banner.small_stripes.yellow": "Veer jäle Pöl",
  "block.minecraft.banner.square_bottom_left.black": "Schwatz rächte Ungereck",
  "block.minecraft.banner.square_bottom_left.blue": "Blau rächte Ungereck",
  "block.minecraft.banner.square_bottom_left.brown": "Brung rächte Ungereck",
  "block.minecraft.banner.square_bottom_left.cyan": "Blaujrön rächte Ungereck",
  "block.minecraft.banner.square_bottom_left.gray": "Jrau rächte Ungereck",
  "block.minecraft.banner.square_bottom_left.green": "Jrön rächte Ungereck",
  "block.minecraft.banner.square_bottom_left.light_blue": "Hellblau rächte Ungereck",
  "block.minecraft.banner.square_bottom_left.light_gray": "Helljrau rächte Ungereck",
  "block.minecraft.banner.square_bottom_left.lime": "Helljrön rächte Ungereck",
  "block.minecraft.banner.square_bottom_left.magenta": "Majenta rächte Ungereck",
  "block.minecraft.banner.square_bottom_left.orange": "Orangsch rächte Ungereck",
  "block.minecraft.banner.square_bottom_left.pink": "Rusa rächte Ungereck",
  "block.minecraft.banner.square_bottom_left.purple": "Vijelett rächte Ungereck",
  "block.minecraft.banner.square_bottom_left.red": "Rut rächte Ungereck",
  "block.minecraft.banner.square_bottom_left.white": "Wieß rächte Ungereck",
  "block.minecraft.banner.square_bottom_left.yellow": "Jäl rächte Ungereck",
  "block.minecraft.banner.square_bottom_right.black": "Schwatz linke Ungereck",
  "block.minecraft.banner.square_bottom_right.blue": "Blau linke Ungereck",
  "block.minecraft.banner.square_bottom_right.brown": "Brung linke Ungereck",
  "block.minecraft.banner.square_bottom_right.cyan": "Blaujrön linke Ungereck",
  "block.minecraft.banner.square_bottom_right.gray": "Jrau linke Ungereck",
  "block.minecraft.banner.square_bottom_right.green": "Jrön linke Ungereck",
  "block.minecraft.banner.square_bottom_right.light_blue": "Hellblau linke Ungereck",
  "block.minecraft.banner.square_bottom_right.light_gray": "Helljrau linke Ungereck",
  "block.minecraft.banner.square_bottom_right.lime": "Helljrön linke Ungereck",
  "block.minecraft.banner.square_bottom_right.magenta": "Majenta linke Ungereck",
  "block.minecraft.banner.square_bottom_right.orange": "Orangsch linke Ungereck",
  "block.minecraft.banner.square_bottom_right.pink": "Rusa linke Ungereck",
  "block.minecraft.banner.square_bottom_right.purple": "Vijelett linke Ungereck",
  "block.minecraft.banner.square_bottom_right.red": "Rut linke Ungereck",
  "block.minecraft.banner.square_bottom_right.white": "Wieß linke Ungereck",
  "block.minecraft.banner.square_bottom_right.yellow": "Jäl linke Ungereck",
  "block.minecraft.banner.square_top_left.black": "Schwatz rächte Bovveneck",
  "block.minecraft.banner.square_top_left.blue": "Blau rächte Bovveneck",
  "block.minecraft.banner.square_top_left.brown": "Brung rächte Bovveneck",
  "block.minecraft.banner.square_top_left.cyan": "Blaujrön rächte Bovveneck",
  "block.minecraft.banner.square_top_left.gray": "Jrau rächte Bovveneck",
  "block.minecraft.banner.square_top_left.green": "Jrön rächte Bovveneck",
  "block.minecraft.banner.square_top_left.light_blue": "Hellblau rächte Bovveneck",
  "block.minecraft.banner.square_top_left.light_gray": "Helljrau rächte Bovveneck",
  "block.minecraft.banner.square_top_left.lime": "Helljrön rächte Bovveneck",
  "block.minecraft.banner.square_top_left.magenta": "Majenta rächte Bovveneck",
  "block.minecraft.banner.square_top_left.orange": "Orangsch rächte Bovveneck",
  "block.minecraft.banner.square_top_left.pink": "Rusa rächte Bovveneck",
  "block.minecraft.banner.square_top_left.purple": "Vijelett rächte Bovveneck",
  "block.minecraft.banner.square_top_left.red": "Rut rächte Bovveneck",
  "block.minecraft.banner.square_top_left.white": "Wieß rächte Bovveneck",
  "block.minecraft.banner.square_top_left.yellow": "Jäl rächte Bovveneck",
  "block.minecraft.banner.square_top_right.black": "Schwatz linke Bovveneck",
  "block.minecraft.banner.square_top_right.blue": "Blau linke Bovveneck",
  "block.minecraft.banner.square_top_right.brown": "Brung linke Bovveneck",
  "block.minecraft.banner.square_top_right.cyan": "Blaujrön linke Bovveneck",
  "block.minecraft.banner.square_top_right.gray": "Jrau linke Bovveneck",
  "block.minecraft.banner.square_top_right.green": "Jrön linke Bovveneck",
  "block.minecraft.banner.square_top_right.light_blue": "Hellblau linke Bovveneck",
  "block.minecraft.banner.square_top_right.light_gray": "Helljrau linke Bovveneck",
  "block.minecraft.banner.square_top_right.lime": "Helljrön linke Bovveneck",
  "block.minecraft.banner.square_top_right.magenta": "Majenta linke Bovveneck",
  "block.minecraft.banner.square_top_right.orange": "Orangsch linke Bovveneck",
  "block.minecraft.banner.square_top_right.pink": "Rusa linke Bovveneck",
  "block.minecraft.banner.square_top_right.purple": "Vijelett linke Bovveneck",
  "block.minecraft.banner.square_top_right.red": "Rut linke Bovveneck",
  "block.minecraft.banner.square_top_right.white": "Wieß linke Bovveneck",
  "block.minecraft.banner.square_top_right.yellow": "Jäl linke Bovveneck",
  "block.minecraft.banner.straight_cross.black": "Schwatz Krütz",
  "block.minecraft.banner.straight_cross.blue": "Blau Krütz",
  "block.minecraft.banner.straight_cross.brown": "Brung Krütz",
  "block.minecraft.banner.straight_cross.cyan": "Blaujrön Krütz",
  "block.minecraft.banner.straight_cross.gray": "Jrau Krütz",
  "block.minecraft.banner.straight_cross.green": "Jrön Krütz",
  "block.minecraft.banner.straight_cross.light_blue": "Hellblau Krütz",
  "block.minecraft.banner.straight_cross.light_gray": "Helljrau Krütz",
  "block.minecraft.banner.straight_cross.lime": "Helljrön Krütz",
  "block.minecraft.banner.straight_cross.magenta": "Majenta Krütz",
  "block.minecraft.banner.straight_cross.orange": "Orangsch Krütz",
  "block.minecraft.banner.straight_cross.pink": "Rusa Krütz",
  "block.minecraft.banner.straight_cross.purple": "Vijelett Krütz",
  "block.minecraft.banner.straight_cross.red": "Rude Krütz",
  "block.minecraft.banner.straight_cross.white": "Wieß Krütz",
  "block.minecraft.banner.straight_cross.yellow": "Jäl Krütz",
  "block.minecraft.banner.stripe_bottom.black": "Schwatze Fahnefoß",
  "block.minecraft.banner.stripe_bottom.blue": "Blaue Fahnefoß",
  "block.minecraft.banner.stripe_bottom.brown": "Brunge Fahnefoß",
  "block.minecraft.banner.stripe_bottom.cyan": "Blaujröne Fahnefoß",
  "block.minecraft.banner.stripe_bottom.gray": "Jraue Fahnefoß",
  "block.minecraft.banner.stripe_bottom.green": "Jröne Fahnefoß",
  "block.minecraft.banner.stripe_bottom.light_blue": "Hellblaue Fahnefoß",
  "block.minecraft.banner.stripe_bottom.light_gray": "Helljraue Fahnefoß",
  "block.minecraft.banner.stripe_bottom.lime": "Helljröne Fahnefoß",
  "block.minecraft.banner.stripe_bottom.magenta": "Majenta Fahnefoß",
  "block.minecraft.banner.stripe_bottom.orange": "Orangsche Fahnefoß",
  "block.minecraft.banner.stripe_bottom.pink": "Rusa Fahnefoß",
  "block.minecraft.banner.stripe_bottom.purple": "Vijelette Fahnefoß",
  "block.minecraft.banner.stripe_bottom.red": "Rude Fahnefoß",
  "block.minecraft.banner.stripe_bottom.white": "Wieße Fahnefoß",
  "block.minecraft.banner.stripe_bottom.yellow": "Jäle Fahnefoß",
  "block.minecraft.banner.stripe_center.black": "Schwatze Pol",
  "block.minecraft.banner.stripe_center.blue": "Blaue Pol",
  "block.minecraft.banner.stripe_center.brown": "Brunge Pol",
  "block.minecraft.banner.stripe_center.cyan": "Blaujröne Pol",
  "block.minecraft.banner.stripe_center.gray": "Jraue Pol",
  "block.minecraft.banner.stripe_center.green": "Jröne Pol",
  "block.minecraft.banner.stripe_center.light_blue": "Hellblaue Pol",
  "block.minecraft.banner.stripe_center.light_gray": "Helljraue Pol",
  "block.minecraft.banner.stripe_center.lime": "Helljröne Pol",
  "block.minecraft.banner.stripe_center.magenta": "Majenta Pol",
  "block.minecraft.banner.stripe_center.orange": "Orangsche Pol",
  "block.minecraft.banner.stripe_center.pink": "Rusa Pol",
  "block.minecraft.banner.stripe_center.purple": "Vijelette Pol",
  "block.minecraft.banner.stripe_center.red": "Rude Pol",
  "block.minecraft.banner.stripe_center.white": "Wieße Pol",
  "block.minecraft.banner.stripe_center.yellow": "Jäl Pol",
  "block.minecraft.banner.stripe_downleft.black": "Schwatze Schällinksbalke",
  "block.minecraft.banner.stripe_downleft.blue": "Blaue Schällinksbalke",
  "block.minecraft.banner.stripe_downleft.brown": "Brunge Schällinksbalke",
  "block.minecraft.banner.stripe_downleft.cyan": "Blaujröne Schällinksbalke",
  "block.minecraft.banner.stripe_downleft.gray": "Jraue Schällinksbalke",
  "block.minecraft.banner.stripe_downleft.green": "Jröne Schällinksbalke",
  "block.minecraft.banner.stripe_downleft.light_blue": "Hellblaue Schällinksbalke",
  "block.minecraft.banner.stripe_downleft.light_gray": "Helljraue Schällinksbalke",
  "block.minecraft.banner.stripe_downleft.lime": "Helljröne Schällinksbalke",
  "block.minecraft.banner.stripe_downleft.magenta": "Majenta Schällinksbalke",
  "block.minecraft.banner.stripe_downleft.orange": "Orangsche Schällinksbalke",
  "block.minecraft.banner.stripe_downleft.pink": "Rusa Schällinksbalke",
  "block.minecraft.banner.stripe_downleft.purple": "Vijelette Schällinksbalke",
  "block.minecraft.banner.stripe_downleft.red": "Rude Schällinksbalke",
  "block.minecraft.banner.stripe_downleft.white": "Wieße Schällinksbalke",
  "block.minecraft.banner.stripe_downleft.yellow": "Jäle Schällinksbalke",
  "block.minecraft.banner.stripe_downright.black": "Schwatze Schrächbalke",
  "block.minecraft.banner.stripe_downright.blue": "Blaue Schrächbalke",
  "block.minecraft.banner.stripe_downright.brown": "Brunge Schrächbalke",
  "block.minecraft.banner.stripe_downright.cyan": "Blaujröne Schrächbalke",
  "block.minecraft.banner.stripe_downright.gray": "Jraue Schrächbalke",
  "block.minecraft.banner.stripe_downright.green": "Jröne Schrächbalke",
  "block.minecraft.banner.stripe_downright.light_blue": "Hellblaue Schrächbalke",
  "block.minecraft.banner.stripe_downright.light_gray": "Helljraue Schrächbalke",
  "block.minecraft.banner.stripe_downright.lime": "Helljröne Schrächbalke",
  "block.minecraft.banner.stripe_downright.magenta": "Majenta Schrächbalke",
  "block.minecraft.banner.stripe_downright.orange": "Orangsche Schrächbalke",
  "block.minecraft.banner.stripe_downright.pink": "Rusa Schrächbalke",
  "block.minecraft.banner.stripe_downright.purple": "Vijelette Schrächbalke",
  "block.minecraft.banner.stripe_downright.red": "Rude Schrächbalke",
  "block.minecraft.banner.stripe_downright.white": "Wieße  Schrächbalke",
  "block.minecraft.banner.stripe_downright.yellow": "Jäle Schrächbalke",
  "block.minecraft.banner.stripe_left.black": "Schwatz rächte Flank",
  "block.minecraft.banner.stripe_left.blue": "Blau rächte Flank",
  "block.minecraft.banner.stripe_left.brown": "Brung rächte Flank",
  "block.minecraft.banner.stripe_left.cyan": "Blaujrön rächte Flank",
  "block.minecraft.banner.stripe_left.gray": "Jrau rächte Flank",
  "block.minecraft.banner.stripe_left.green": "Jrön rächte Flank",
  "block.minecraft.banner.stripe_left.light_blue": "Hellblau rächte Flank",
  "block.minecraft.banner.stripe_left.light_gray": "Helljrau rächte Flank",
  "block.minecraft.banner.stripe_left.lime": "Helljrön rächte Flank",
  "block.minecraft.banner.stripe_left.magenta": "Majenta rächte Flank",
  "block.minecraft.banner.stripe_left.orange": "Orangsch rächte Flank",
  "block.minecraft.banner.stripe_left.pink": "Rusa rächte Flank",
  "block.minecraft.banner.stripe_left.purple": "Vijelett rächte Flank",
  "block.minecraft.banner.stripe_left.red": "Rut rächte Flank",
  "block.minecraft.banner.stripe_left.white": "Wieß rächte Flank",
  "block.minecraft.banner.stripe_left.yellow": "Jäl rächte Flank",
  "block.minecraft.banner.stripe_middle.black": "Schwatze Balke",
  "block.minecraft.banner.stripe_middle.blue": "Blaue Balke",
  "block.minecraft.banner.stripe_middle.brown": "Brunge Balke",
  "block.minecraft.banner.stripe_middle.cyan": "Blaujröne Balke",
  "block.minecraft.banner.stripe_middle.gray": "Jraue Balke",
  "block.minecraft.banner.stripe_middle.green": "Jröne Balke",
  "block.minecraft.banner.stripe_middle.light_blue": "Hellblaue Balke",
  "block.minecraft.banner.stripe_middle.light_gray": "Helljraue Balke",
  "block.minecraft.banner.stripe_middle.lime": "Helljröne Balke",
  "block.minecraft.banner.stripe_middle.magenta": "Majenta Balke",
  "block.minecraft.banner.stripe_middle.orange": "Orangsche Balke",
  "block.minecraft.banner.stripe_middle.pink": "Rusa Balke",
  "block.minecraft.banner.stripe_middle.purple": "Vijelette Balke",
  "block.minecraft.banner.stripe_middle.red": "Rude Balke",
  "block.minecraft.banner.stripe_middle.white": "Wieße Balke",
  "block.minecraft.banner.stripe_middle.yellow": "Jäle Balke",
  "block.minecraft.banner.stripe_right.black": "Schwatz linke Flank",
  "block.minecraft.banner.stripe_right.blue": "Blau linke Flank",
  "block.minecraft.banner.stripe_right.brown": "Brung linke Flank",
  "block.minecraft.banner.stripe_right.cyan": "Blaujrön linke Flank",
  "block.minecraft.banner.stripe_right.gray": "Jrau linke Flank",
  "block.minecraft.banner.stripe_right.green": "Jrön linke Flank",
  "block.minecraft.banner.stripe_right.light_blue": "Hellblau linke Flank",
  "block.minecraft.banner.stripe_right.light_gray": "Helljrau linke Flank",
  "block.minecraft.banner.stripe_right.lime": "Helljrön linke Flank",
  "block.minecraft.banner.stripe_right.magenta": "Majenta linke Flank",
  "block.minecraft.banner.stripe_right.orange": "Orangsch linke Flank",
  "block.minecraft.banner.stripe_right.pink": "Rusa linke Flank",
  "block.minecraft.banner.stripe_right.purple": "Vijelett linke Flank",
  "block.minecraft.banner.stripe_right.red": "Rut linke Flank",
  "block.minecraft.banner.stripe_right.white": "Wieß linke Flank",
  "block.minecraft.banner.stripe_right.yellow": "Jäl linke Flank",
  "block.minecraft.banner.stripe_top.black": "Schwatze Fahnekopp",
  "block.minecraft.banner.stripe_top.blue": "Blaue Fahnekopp",
  "block.minecraft.banner.stripe_top.brown": "Brunge Fahnekopp",
  "block.minecraft.banner.stripe_top.cyan": "Blaujröne Fahnekopp",
  "block.minecraft.banner.stripe_top.gray": "Jraue Fahnekopp",
  "block.minecraft.banner.stripe_top.green": "Jröne Fahnekopp",
  "block.minecraft.banner.stripe_top.light_blue": "Hellblaue Fahnekopp",
  "block.minecraft.banner.stripe_top.light_gray": "Helljraue Fahnekopp",
  "block.minecraft.banner.stripe_top.lime": "Helljröne Fahnekopp",
  "block.minecraft.banner.stripe_top.magenta": "Majenta Fahnekopp",
  "block.minecraft.banner.stripe_top.orange": "Orangsche Fahnekopp",
  "block.minecraft.banner.stripe_top.pink": "Rusa Fahnekopp",
  "block.minecraft.banner.stripe_top.purple": "Vijelette Fahnekopp",
  "block.minecraft.banner.stripe_top.red": "Rude Fahnekopp",
  "block.minecraft.banner.stripe_top.white": "Wieße Fahnekopp",
  "block.minecraft.banner.stripe_top.yellow": "Jäle Fahnekopp",
  "block.minecraft.banner.triangle_bottom.black": "Schwatz halve Spetz",
  "block.minecraft.banner.triangle_bottom.blue": "Blau halve Spetz",
  "block.minecraft.banner.triangle_bottom.brown": "Brung halve Spetz",
  "block.minecraft.banner.triangle_bottom.cyan": "Blaujrön halve Spetz",
  "block.minecraft.banner.triangle_bottom.gray": "Jrau halve Spetz",
  "block.minecraft.banner.triangle_bottom.green": "Jrön halve Spetz",
  "block.minecraft.banner.triangle_bottom.light_blue": "Hellblau halve Spetz",
  "block.minecraft.banner.triangle_bottom.light_gray": "Helljrau halve Spetz",
  "block.minecraft.banner.triangle_bottom.lime": "Helljrön halve Spetz",
  "block.minecraft.banner.triangle_bottom.magenta": "Majenta halve Spetz",
  "block.minecraft.banner.triangle_bottom.orange": "Orangsch halve Spetz",
  "block.minecraft.banner.triangle_bottom.pink": "Rusa halve Spetz",
  "block.minecraft.banner.triangle_bottom.purple": "Vijelett halve Spetz",
  "block.minecraft.banner.triangle_bottom.red": "Rut halve Spetz",
  "block.minecraft.banner.triangle_bottom.white": "Wieß halve Spetz",
  "block.minecraft.banner.triangle_bottom.yellow": "Jäl halve Spetz",
  "block.minecraft.banner.triangle_top.black": "Schwatz jestöz halve Spetz",
  "block.minecraft.banner.triangle_top.blue": "Blau jestöz halve Spetz",
  "block.minecraft.banner.triangle_top.brown": "Brung jestöz halve Spetz",
  "block.minecraft.banner.triangle_top.cyan": "Blaujrön jestöz halve Spetz",
  "block.minecraft.banner.triangle_top.gray": "Jrau jestöz halve Spetz",
  "block.minecraft.banner.triangle_top.green": "Jrön jestöz halve Spetz",
  "block.minecraft.banner.triangle_top.light_blue": "Hellblau jestöz halve Spetz",
  "block.minecraft.banner.triangle_top.light_gray": "Helljrau jestöz halve Spetz",
  "block.minecraft.banner.triangle_top.lime": "Helljrön jestöz halve Spetz",
  "block.minecraft.banner.triangle_top.magenta": "Majenta jestöz halve Spetz",
  "block.minecraft.banner.triangle_top.orange": "Orangsch jestöz halve Spetz",
  "block.minecraft.banner.triangle_top.pink": "Rusa jestöz halve Spetz",
  "block.minecraft.banner.triangle_top.purple": "Vijelett jestöz halve Spetz",
  "block.minecraft.banner.triangle_top.red": "Rut jestöz halve Spetz",
  "block.minecraft.banner.triangle_top.white": "Wieß jestöz halve Spetz",
  "block.minecraft.banner.triangle_top.yellow": "Jäl jestöz halve Spetz",
  "block.minecraft.banner.triangles_bottom.black": "Schwatze jespickelt Fahnefoß",
  "block.minecraft.banner.triangles_bottom.blue": "Blaue jespickelt Fahnefoß",
  "block.minecraft.banner.triangles_bottom.brown": "Brunge jespickelt Fahnefoß",
  "block.minecraft.banner.triangles_bottom.cyan": "Blaujröne jespickelt Fahnefoß",
  "block.minecraft.banner.triangles_bottom.gray": "Jraue jespickelt Fahnefoß",
  "block.minecraft.banner.triangles_bottom.green": "Jröne jespickelt Fahnefoß",
  "block.minecraft.banner.triangles_bottom.light_blue": "Hellblaue jespickelt Fahnefoß",
  "block.minecraft.banner.triangles_bottom.light_gray": "Helljraue jespickelt Fahnefoß",
  "block.minecraft.banner.triangles_bottom.lime": "Helljröne jespickelt Fahnefoß",
  "block.minecraft.banner.triangles_bottom.magenta": "Majenta jespickelt Fahnefoß",
  "block.minecraft.banner.triangles_bottom.orange": "Orangsche jespickelt Fahnefoß",
  "block.minecraft.banner.triangles_bottom.pink": "Rusa jespickelt Fahnefoß",
  "block.minecraft.banner.triangles_bottom.purple": "Vijelette jespickelt Fahnefoß",
  "block.minecraft.banner.triangles_bottom.red": "Rude jespickelt Fahnefoß",
  "block.minecraft.banner.triangles_bottom.white": "Wieße jespickelt Fahnefoß",
  "block.minecraft.banner.triangles_bottom.yellow": "Jäle jespickelt Fahnefoß",
  "block.minecraft.banner.triangles_top.black": "Schwatze jespickelt Fahnekopp",
  "block.minecraft.banner.triangles_top.blue": "Blaue jespickelt Fahnekopp",
  "block.minecraft.banner.triangles_top.brown": "Brunge jespickelt Fahnekopp",
  "block.minecraft.banner.triangles_top.cyan": "Blaujröne jespickelt Fahnekopp",
  "block.minecraft.banner.triangles_top.gray": "Jraue jespickelt Fahnekopp",
  "block.minecraft.banner.triangles_top.green": "Jröne jespickelt Fahnekopp",
  "block.minecraft.banner.triangles_top.light_blue": "Hellblaue jespickelt Fahnekopp",
  "block.minecraft.banner.triangles_top.light_gray": "Helljraue jespickelt Fahnekopp",
  "block.minecraft.banner.triangles_top.lime": "Helljröne jespickelt Fahnekopp",
  "block.minecraft.banner.triangles_top.magenta": "Majenta jespickelt Fahnekopp",
  "block.minecraft.banner.triangles_top.orange": "Orangsche jespickelt Fahnekopp",
  "block.minecraft.banner.triangles_top.pink": "Rusa jespickelt Fahnekopp",
  "block.minecraft.banner.triangles_top.purple": "Vijelette jespickelt Fahnekopp",
  "block.minecraft.banner.triangles_top.red": "Rude jespickelt Fahnekopp",
  "block.minecraft.banner.triangles_top.white": "Wieße jespickelt Fahnekopp",
  "block.minecraft.banner.triangles_top.yellow": "Jäle jespickelt Fahnekopp",
  "block.minecraft.barrel": "Faaß",
  "block.minecraft.barrier": "Barrjär",
  "block.minecraft.basalt": "Basalt",
  "block.minecraft.beacon": "Lööchför",
  "block.minecraft.beacon.primary": "Eetste Kraff",
  "block.minecraft.beacon.secondary": "Zwede Kraff",
  "block.minecraft.bed.no_sleep": "Do kanns blos naaks udder während Jewedder schlofe",
  "block.minecraft.bed.not_safe": "Do kanns jetz nit schlofe, et sin Monster en der Nöh",
  "block.minecraft.bed.obstructed": "Dat Bett es blockeet",
  "block.minecraft.bed.occupied": "Dat Bett es belaat",
  "block.minecraft.bed.too_far_away": "Do kanns jetz nit schlofe, dat Bett es ze wick fott",
  "block.minecraft.bedrock": "Jrundjestein",
  "block.minecraft.bee_nest": "Beieneß",
  "block.minecraft.beehive": "Beiestock",
  "block.minecraft.beetroots": "Rude Bete",
  "block.minecraft.bell": "Klock",
  "block.minecraft.big_dripleaf": "Großes Tropfblatt",
  "block.minecraft.big_dripleaf_stem": "Großer Tropfblattstiel",
  "block.minecraft.birch_button": "Birkeholzknopp",
  "block.minecraft.birch_door": "Birkeholzdür",
  "block.minecraft.birch_fence": "Birkeholzzong",
  "block.minecraft.birch_fence_gate": "Birkeholzjadder",
  "block.minecraft.birch_hanging_sign": "Birkenholzhängeschild",
  "block.minecraft.birch_leaves": "Birkelauv",
  "block.minecraft.birch_log": "Birkestamm",
  "block.minecraft.birch_planks": "Birkeholzbredder",
  "block.minecraft.birch_pressure_plate": "Birkeholzdröckplaat",
  "block.minecraft.birch_sapling": "Birkeböumche",
  "block.minecraft.birch_shelf": "Birkenholzregal",
  "block.minecraft.birch_sign": "Birkeholzscheld",
  "block.minecraft.birch_slab": "Birkeholzstof",
  "block.minecraft.birch_stairs": "Birkeholztrapp",
  "block.minecraft.birch_trapdoor": "Birkeholztrappdür",
  "block.minecraft.birch_wall_hanging_sign": "Birkenholzwandhängeschild",
  "block.minecraft.birch_wall_sign": "Birkeholzwandscheld",
  "block.minecraft.birch_wood": "Birkeholz",
  "block.minecraft.black_banner": "Schwatze Fahn",
  "block.minecraft.black_bed": "Schwatz Bett",
  "block.minecraft.black_candle": "Schwatze Käz",
  "block.minecraft.black_candle_cake": "Kooche met schwatze Kääz",
  "block.minecraft.black_carpet": "Schwatze Teppich",
  "block.minecraft.black_concrete": "Schwatze Betong",
  "block.minecraft.black_concrete_powder": "Schwatze Drüchbetong",
  "block.minecraft.black_glazed_terracotta": "Schwatz jlaseet Steinjot",
  "block.minecraft.black_shulker_box": "Schwatz Shulker-Keß",
  "block.minecraft.black_stained_glass": "Schwatz jefärv Jlas",
  "block.minecraft.black_stained_glass_pane": "Schwatz jefärv Jlasschiev",
  "block.minecraft.black_terracotta": "Schwatz Steinjot",
  "block.minecraft.black_wool": "Schwatze Woll",
  "block.minecraft.blackstone": "Schwatzstein",
  "block.minecraft.blackstone_slab": "Schwatzsteinstof",
  "block.minecraft.blackstone_stairs": "Schwatzsteintrapp",
  "block.minecraft.blackstone_wall": "Schwarzsteinmor",
  "block.minecraft.blast_furnace": "Schmelzovve",
  "block.minecraft.blue_banner": "Blau Fahn",
  "block.minecraft.blue_bed": "Blau Bett",
  "block.minecraft.blue_candle": "Blaue Käz",
  "block.minecraft.blue_candle_cake": "Kooche met blaue Kääz",
  "block.minecraft.blue_carpet": "Blaue Teppich",
  "block.minecraft.blue_concrete": "Blaue Betong",
  "block.minecraft.blue_concrete_powder": "Blaue Drüchbetong",
  "block.minecraft.blue_glazed_terracotta": "Blau jlaseet Steinjot",
  "block.minecraft.blue_ice": "Blauies",
  "block.minecraft.blue_orchid": "Blau Orschidee",
  "block.minecraft.blue_shulker_box": "Blau Shulker-Keß",
  "block.minecraft.blue_stained_glass": "Blau jefärv Jlas",
  "block.minecraft.blue_stained_glass_pane": "Blau jefärv Jlasschiev",
  "block.minecraft.blue_terracotta": "Blau Steinjot",
  "block.minecraft.blue_wool": "Blaue Woll",
  "block.minecraft.bone_block": "Knoche",
  "block.minecraft.bookshelf": "Böcherejal",
  "block.minecraft.brain_coral": "Jehirnkorall",
  "block.minecraft.brain_coral_block": "Jehirnkoralleblock",
  "block.minecraft.brain_coral_fan": "Jehirnkorallefächer",
  "block.minecraft.brain_coral_wall_fan": "Jehirnkorallewandfächer",
  "block.minecraft.brewing_stand": "Braues",
  "block.minecraft.brick_slab": "Ziejelstof",
  "block.minecraft.brick_stairs": "Ziejeltrapp",
  "block.minecraft.brick_wall": "Ziejelsteinmor",
  "block.minecraft.bricks": "Ziejelstein",
  "block.minecraft.brown_banner": "Brung Fahn",
  "block.minecraft.brown_bed": "Brung Bett",
  "block.minecraft.brown_candle": "Brunge Käz",
  "block.minecraft.brown_candle_cake": "Kooche met brunge Kääz",
  "block.minecraft.brown_carpet": "Brunge Teppich",
  "block.minecraft.brown_concrete": "Brunge Betong",
  "block.minecraft.brown_concrete_powder": "Brunge Drüchbetong",
  "block.minecraft.brown_glazed_terracotta": "Brung jlaseet Steinjot",
  "block.minecraft.brown_mushroom": "Brunge Pelz",
  "block.minecraft.brown_mushroom_block": "Brunge Pelz",
  "block.minecraft.brown_shulker_box": "Brung Shulker-Keß",
  "block.minecraft.brown_stained_glass": "Brung jefärv Jlas",
  "block.minecraft.brown_stained_glass_pane": "Brung jefärv Jlasschiev",
  "block.minecraft.brown_terracotta": "Brung Steinjot",
  "block.minecraft.brown_wool": "Brunge Woll",
  "block.minecraft.bubble_column": "Blose",
  "block.minecraft.bubble_coral": "Blosekorall",
  "block.minecraft.bubble_coral_block": "Blosekoralleblock",
  "block.minecraft.bubble_coral_fan": "Blosekorallefächer",
  "block.minecraft.bubble_coral_wall_fan": "Blosekorallewandfächer",
  "block.minecraft.budding_amethyst": "Ametüstknoppblock",
  "block.minecraft.bush": "Busch",
  "block.minecraft.cactus": "Kaktus",
  "block.minecraft.cactus_flower": "Kaktusblüte",
  "block.minecraft.cake": "Koche",
  "block.minecraft.calcite": "Kalzit",
  "block.minecraft.calibrated_sculk_sensor": "Kalibrierter Sculk-Sensor",
  "block.minecraft.campfire": "Förstell",
  "block.minecraft.candle": "Käz",
  "block.minecraft.candle_cake": "Koche met Käz",
  "block.minecraft.carrots": "Murre",
  "block.minecraft.cartography_table": "Kaatedesch",
  "block.minecraft.carved_pumpkin": "Jeschnitze Kürbis",
  "block.minecraft.cauldron": "Bütt",
  "block.minecraft.cave_air": "Höhleluff",
  "block.minecraft.cave_vines": "Höhleranke",
  "block.minecraft.cave_vines_plant": "Höhlerankepflant",
  "block.minecraft.chain": "Kett",
  "block.minecraft.chain_command_block": "Kette-Befellsblock",
  "block.minecraft.cherry_button": "Kirschholzknopf",
  "block.minecraft.cherry_door": "Kirschholztür",
  "block.minecraft.cherry_fence": "Kirschholzzaun",
  "block.minecraft.cherry_fence_gate": "Kirschholzzauntor",
  "block.minecraft.cherry_hanging_sign": "Kirschholzhängeschild",
  "block.minecraft.cherry_leaves": "Kirschlaub",
  "block.minecraft.cherry_log": "Kirschstamm",
  "block.minecraft.cherry_planks": "Kirschholzbretter",
  "block.minecraft.cherry_pressure_plate": "Kirschholzdruckplatte",
  "block.minecraft.cherry_sapling": "Kirschsetzling",
  "block.minecraft.cherry_shelf": "Kirschholzregal",
  "block.minecraft.cherry_sign": "Kirschholzschild",
  "block.minecraft.cherry_slab": "Kirschholzstufe",
  "block.minecraft.cherry_stairs": "Kirschholztreppe",
  "block.minecraft.cherry_trapdoor": "Kirschholzfalltür",
  "block.minecraft.cherry_wall_hanging_sign": "Kirschholzwandhängeschild",
  "block.minecraft.cherry_wall_sign": "Kirschholzwandschild",
  "block.minecraft.cherry_wood": "Kirschholz",
  "block.minecraft.chest": "Keß",
  "block.minecraft.chipped_anvil": "Anjedötsche Amboß",
  "block.minecraft.chiseled_bookshelf": "Gearbeitetes Bücherregal",
  "block.minecraft.chiseled_copper": "Gemeißelter Kupferblock",
  "block.minecraft.chiseled_deepslate": "Ziseleete Deefdenleie",
  "block.minecraft.chiseled_nether_bricks": "Ziseleete Netherziejel",
  "block.minecraft.chiseled_polished_blackstone": "Ziseleete poleete Schwatzstein",
  "block.minecraft.chiseled_quartz_block": "Ziseleete Kwarz",
  "block.minecraft.chiseled_red_sandstone": "Ziseleete rude Sandstein",
  "block.minecraft.chiseled_resin_bricks": "Gemeißelte Harzziegel",
  "block.minecraft.chiseled_sandstone": "Ziseleete Sandstein",
  "block.minecraft.chiseled_stone_bricks": "Ziseleete Steinziejel",
  "block.minecraft.chiseled_tuff": "Gemeißelter Tuffstein",
  "block.minecraft.chiseled_tuff_bricks": "Gemeißelte Tuffsteinziegel",
  "block.minecraft.chorus_flower": "Chorusblom",
  "block.minecraft.chorus_plant": "Chorusplant",
  "block.minecraft.clay": "Klei",
  "block.minecraft.closed_eyeblossom": "Geschlossene Augenblüte",
  "block.minecraft.coal_block": "Koll",
  "block.minecraft.coal_ore": "Steinkoll",
  "block.minecraft.coarse_dirt": "Jrov Äd",
  "block.minecraft.cobbled_deepslate": "Brochdeefdenleie",
  "block.minecraft.cobbled_deepslate_slab": "Brochdeefdenleiestof",
  "block.minecraft.cobbled_deepslate_stairs": "Brochdeefdenleietrapp",
  "block.minecraft.cobbled_deepslate_wall": "Brochdeefdenleiemor",
  "block.minecraft.cobblestone": "Brochstein",
  "block.minecraft.cobblestone_slab": "Brochsteinstof",
  "block.minecraft.cobblestone_stairs": "Brochsteintrapp",
  "block.minecraft.cobblestone_wall": "Brochsteinmor",
  "block.minecraft.cobweb": "Spenneweb",
  "block.minecraft.cocoa": "Kakau",
  "block.minecraft.command_block": "Befellsblock",
  "block.minecraft.comparator": "Redstone-Verjliche",
  "block.minecraft.composter": "Kompoß",
  "block.minecraft.conduit": "Aquisatör",
  "block.minecraft.copper_bars": "Kupfergitter",
  "block.minecraft.copper_block": "Kofferblock",
  "block.minecraft.copper_bulb": "Kupferleuchte",
  "block.minecraft.copper_chain": "Kupferkette",
  "block.minecraft.copper_chest": "Kupfertruhe",
  "block.minecraft.copper_door": "Kupfertür",
  "block.minecraft.copper_golem_statue": "Kupfergolemstatue",
  "block.minecraft.copper_grate": "Kupferrost",
  "block.minecraft.copper_lantern": "Kupferlaterne",
  "block.minecraft.copper_ore": "Kofferärz",
  "block.minecraft.copper_torch": "Kupferfackel",
  "block.minecraft.copper_trapdoor": "Kupferfalltür",
  "block.minecraft.copper_wall_torch": "Kupferwandfackel",
  "block.minecraft.cornflower": "Kornblom",
  "block.minecraft.cracked_deepslate_bricks": "Jeresse Deefdenleieziejel",
  "block.minecraft.cracked_deepslate_tiles": "Jeresse Deefdenleieplaate",
  "block.minecraft.cracked_nether_bricks": "Jeresse Netherziejel",
  "block.minecraft.cracked_polished_blackstone_bricks": "Jeresse poleete Schwatzsteinziejel",
  "block.minecraft.cracked_stone_bricks": "Jeresse Steinziejel",
  "block.minecraft.crafter": "Werker",
  "block.minecraft.crafting_table": "Werkbank",
  "block.minecraft.creaking_heart": "Knarzherz",
  "block.minecraft.creeper_head": "Creeperkopp",
  "block.minecraft.creeper_wall_head": "Creeperwandkopp",
  "block.minecraft.crimson_button": "Karmesinnknopp",
  "block.minecraft.crimson_door": "Karmesinndür",
  "block.minecraft.crimson_fence": "Karmesinnzong",
  "block.minecraft.crimson_fence_gate": "Karmesinnjadder",
  "block.minecraft.crimson_fungus": "Karmesinnpelz",
  "block.minecraft.crimson_hanging_sign": "Karmesinhängeschild",
  "block.minecraft.crimson_hyphae": "Karmesinnhüfe",
  "block.minecraft.crimson_nylium": "Karmesinn-Nülliöm",
  "block.minecraft.crimson_planks": "Karmesinnbredder",
  "block.minecraft.crimson_pressure_plate": "Karmesinndröckplaat",
  "block.minecraft.crimson_roots": "Karmesinnwuzzele",
  "block.minecraft.crimson_shelf": "Karmesinregal",
  "block.minecraft.crimson_sign": "Karmesinnscheld",
  "block.minecraft.crimson_slab": "Karmesinnstof",
  "block.minecraft.crimson_stairs": "Karmesinntrapp",
  "block.minecraft.crimson_stem": "Karmesinnstill",
  "block.minecraft.crimson_trapdoor": "Karmesinntrappdür",
  "block.minecraft.crimson_wall_hanging_sign": "Karmesinwandhängeschild",
  "block.minecraft.crimson_wall_sign": "Karmesinnwandscheld",
  "block.minecraft.crying_obsidian": "Krieschende Obssidijan",
  "block.minecraft.cut_copper": "Jeschnigge Koffer",
  "block.minecraft.cut_copper_slab": "Schnigge Kofferstof",
  "block.minecraft.cut_copper_stairs": "Jeschnigge Koffertrapp",
  "block.minecraft.cut_red_sandstone": "Jeschnigge rude Sandstein",
  "block.minecraft.cut_red_sandstone_slab": "Jeschnigge rut Sandsteinstof",
  "block.minecraft.cut_sandstone": "Jeschnigge Sandstein",
  "block.minecraft.cut_sandstone_slab": "Jeschnigge Sandsteinstof",
  "block.minecraft.cyan_banner": "Blaujrön Fahn",
  "block.minecraft.cyan_bed": "Blaujrön Bett",
  "block.minecraft.cyan_candle": "Blaujröne Käz",
  "block.minecraft.cyan_candle_cake": "Kooche met blaujröne Kääz",
  "block.minecraft.cyan_carpet": "Blaujröne Teppich",
  "block.minecraft.cyan_concrete": "Blaujröne Betong",
  "block.minecraft.cyan_concrete_powder": "Blaujröne Drüchbetong",
  "block.minecraft.cyan_glazed_terracotta": "Blaujrön jlaseet Steinjot",
  "block.minecraft.cyan_shulker_box": "Blaujrön Shulker-Keß",
  "block.minecraft.cyan_stained_glass": "Blaujrön jefeärv Jlas",
  "block.minecraft.cyan_stained_glass_pane": "Blaujrön jefeärv Jlasschiev",
  "block.minecraft.cyan_terracotta": "Blaujrön Steinjot",
  "block.minecraft.cyan_wool": "Blaujröne Woll",
  "block.minecraft.damaged_anvil": "Zerblötsch Amboß",
  "block.minecraft.dandelion": "Ketteblom",
  "block.minecraft.dark_oak_button": "Schwatzeescheholzknopp",
  "block.minecraft.dark_oak_door": "Schwatzeescheholzdür",
  "block.minecraft.dark_oak_fence": "Schwatzeescheholzzong",
  "block.minecraft.dark_oak_fence_gate": "Schwatzeescheholzjadder",
  "block.minecraft.dark_oak_hanging_sign": "Schwarzeichenholzhängeschild",
  "block.minecraft.dark_oak_leaves": "Schwatzeeschelauv",
  "block.minecraft.dark_oak_log": "Schwatzeeschestamm",
  "block.minecraft.dark_oak_planks": "Schwatzeescheholzbredder",
  "block.minecraft.dark_oak_pressure_plate": "Schwatzescheholzdröckplaat",
  "block.minecraft.dark_oak_sapling": "Schwatzeescheböumche",
  "block.minecraft.dark_oak_shelf": "Schwarzeichenholzregal",
  "block.minecraft.dark_oak_sign": "Schwatzeescheholzscheld",
  "block.minecraft.dark_oak_slab": "Schwatzeescheholzstof",
  "block.minecraft.dark_oak_stairs": "Schwatzeescheholztrapp",
  "block.minecraft.dark_oak_trapdoor": "Schwatzeescheholztrappdür",
  "block.minecraft.dark_oak_wall_hanging_sign": "Schwarzeichenholzwandhängeschild",
  "block.minecraft.dark_oak_wall_sign": "Schwatzeescheholzwandscheld",
  "block.minecraft.dark_oak_wood": "Schwatzeescheholz",
  "block.minecraft.dark_prismarine": "Dunkle Prismarin",
  "block.minecraft.dark_prismarine_slab": "Dunkle Prismarinstof",
  "block.minecraft.dark_prismarine_stairs": "Dunkle Prismarintrapp",
  "block.minecraft.daylight_detector": "Dachleechföhler",
  "block.minecraft.dead_brain_coral": "Dude Jehirnkorall",
  "block.minecraft.dead_brain_coral_block": "Dude Jehirnkoralleblock",
  "block.minecraft.dead_brain_coral_fan": "Dude Jehirnkorallefächer",
  "block.minecraft.dead_brain_coral_wall_fan": "Dude Jehirnkorallewandfächer",
  "block.minecraft.dead_bubble_coral": "Dude Blosekorall",
  "block.minecraft.dead_bubble_coral_block": "Dude Blosekoralleblock",
  "block.minecraft.dead_bubble_coral_fan": "Dude Blosekorallefächer",
  "block.minecraft.dead_bubble_coral_wall_fan": "Dude Blosekorallewandfächer",
  "block.minecraft.dead_bush": "Dude Struch",
  "block.minecraft.dead_fire_coral": "Dude Förkorall",
  "block.minecraft.dead_fire_coral_block": "Dude Förkoralleblock",
  "block.minecraft.dead_fire_coral_fan": "Dude Förkorallefächer",
  "block.minecraft.dead_fire_coral_wall_fan": "Dude Förkorallewandfächer",
  "block.minecraft.dead_horn_coral": "Dude Jeweihkorall",
  "block.minecraft.dead_horn_coral_block": "Dude Jeweihkoralleblock",
  "block.minecraft.dead_horn_coral_fan": "Dude Jeweihkorallefächer",
  "block.minecraft.dead_horn_coral_wall_fan": "Dude Jeweihkorallewandfächer",
  "block.minecraft.dead_tube_coral": "Dude Orjelkorall",
  "block.minecraft.dead_tube_coral_block": "Dude Orjelkoralleblock",
  "block.minecraft.dead_tube_coral_fan": "Dude Orjelkorallefächer",
  "block.minecraft.dead_tube_coral_wall_fan": "Dude Orjelkorallewandfächer",
  "block.minecraft.decorated_pot": "Verzierter Krug",
  "block.minecraft.deepslate": "Deefdenleie",
  "block.minecraft.deepslate_brick_slab": "Deefdenleieziejelplaat",
  "block.minecraft.deepslate_brick_stairs": "Deefdenleieziejeltrapp",
  "block.minecraft.deepslate_brick_wall": "Deefdenleieziejelmor",
  "block.minecraft.deepslate_bricks": "Deefdenleieziejel",
  "block.minecraft.deepslate_coal_ore": "Deefdenleie-Steinkoll",
  "block.minecraft.deepslate_copper_ore": "Deefdenleie-Kofferärz",
  "block.minecraft.deepslate_diamond_ore": "Deefdenleie-Dijamantärz",
  "block.minecraft.deepslate_emerald_ore": "Deefdenleie-Smarakärz",
  "block.minecraft.deepslate_gold_ore": "Deefdenleie-Joldärz",
  "block.minecraft.deepslate_iron_ore": "Deefdenleie-Ieseärz",
  "block.minecraft.deepslate_lapis_ore": "Deefdenleie-Lapislazoliärz",
  "block.minecraft.deepslate_redstone_ore": "Deefdenleie-Redstone-Ärz",
  "block.minecraft.deepslate_tile_slab": "Deefdenleieplaatestof",
  "block.minecraft.deepslate_tile_stairs": "Deefdenleieplaatetrapp",
  "block.minecraft.deepslate_tile_wall": "Deefdenleieplaatemor",
  "block.minecraft.deepslate_tiles": "Deefdenleieplaate",
  "block.minecraft.detector_rail": "Föhlerschinne",
  "block.minecraft.diamond_block": "Dijamant",
  "block.minecraft.diamond_ore": "Dijamantärz",
  "block.minecraft.diorite": "Dijorit",
  "block.minecraft.diorite_slab": "Dijoritstof",
  "block.minecraft.diorite_stairs": "Dijorittrapp",
  "block.minecraft.diorite_wall": "Dijoritmor",
  "block.minecraft.dirt": "Äd",
  "block.minecraft.dirt_path": "Trampelpfad",
  "block.minecraft.dispenser": "Verdeeler",
  "block.minecraft.dragon_egg": "Drache-Ei",
  "block.minecraft.dragon_head": "Drachekopp",
  "block.minecraft.dragon_wall_head": "Drachewandkopp",
  "block.minecraft.dried_ghast": "Ausgetrockneter Ghast",
  "block.minecraft.dried_kelp_block": "Drüjje Sietangblock",
  "block.minecraft.dripstone_block": "Tropfsteinblock",
  "block.minecraft.dropper": "Usjevver",
  "block.minecraft.emerald_block": "Smarak",
  "block.minecraft.emerald_ore": "Smarakärz",
  "block.minecraft.enchanting_table": "Zauberdesch",
  "block.minecraft.end_gateway": "Engk-Reisepoaz",
  "block.minecraft.end_portal": "Endpoaz",
  "block.minecraft.end_portal_frame": "Endpoazrohme",
  "block.minecraft.end_rod": "Endstang",
  "block.minecraft.end_stone": "Endstein",
  "block.minecraft.end_stone_brick_slab": "Endsteinziejelstof",
  "block.minecraft.end_stone_brick_stairs": "Endsteinziejeltrapp",
  "block.minecraft.end_stone_brick_wall": "Endsteinziejelmor",
  "block.minecraft.end_stone_bricks": "Endsteinziejel",
  "block.minecraft.ender_chest": "Enderkeß",
  "block.minecraft.exposed_chiseled_copper": "Angelaufener gemeißelter Kupferblock",
  "block.minecraft.exposed_copper": "Blänkiche Kofferblock",
  "block.minecraft.exposed_copper_bars": "Angelaufenes Kupfergitter",
  "block.minecraft.exposed_copper_bulb": "Angelaufene Kupferleuchte",
  "block.minecraft.exposed_copper_chain": "Angelaufene Kupferkette",
  "block.minecraft.exposed_copper_chest": "Angelaufene Kupfertruhe",
  "block.minecraft.exposed_copper_door": "Angelaufene Kupfertür",
  "block.minecraft.exposed_copper_golem_statue": "Angelaufene Kupfergolemstatue",
  "block.minecraft.exposed_copper_grate": "Angelaufener Kupferrost",
  "block.minecraft.exposed_copper_lantern": "Angelaufene Kupferlaterne",
  "block.minecraft.exposed_copper_trapdoor": "Angelaufene Kupferfalltür",
  "block.minecraft.exposed_cut_copper": "Blänkiche schnigge Kofferblock",
  "block.minecraft.exposed_cut_copper_slab": "Blänkiche schnigge Kofferstof",
  "block.minecraft.exposed_cut_copper_stairs": "Blänkiche schnigge Koffertrapp",
  "block.minecraft.exposed_lightning_rod": "Angelaufener Blitzableiter",
  "block.minecraft.farmland": "Ackeräd",
  "block.minecraft.fern": "Farre",
  "block.minecraft.fire": "För",
  "block.minecraft.fire_coral": "Förkorall",
  "block.minecraft.fire_coral_block": "Förkoralleblock",
  "block.minecraft.fire_coral_fan": "Förkorallefächer",
  "block.minecraft.fire_coral_wall_fan": "Förkorallewandfächer",
  "block.minecraft.firefly_bush": "Glühwürmchenbusch",
  "block.minecraft.fletching_table": "Pielmächerdesch",
  "block.minecraft.flower_pot": "Blomepot",
  "block.minecraft.flowering_azalea": "Blöhende Azalee",
  "block.minecraft.flowering_azalea_leaves": "Blöhendes Azaleelauv",
  "block.minecraft.frogspawn": "Froschlaich",
  "block.minecraft.frosted_ice": "Brüchich Ies",
  "block.minecraft.furnace": "Ovve",
  "block.minecraft.gilded_blackstone": "Verjoldete Schwatzstein",
  "block.minecraft.glass": "Jlas",
  "block.minecraft.glass_pane": "Jlasschiev",
  "block.minecraft.glow_lichen": "Leuchtflechte",
  "block.minecraft.glowstone": "Lööchstein",
  "block.minecraft.gold_block": "Jold",
  "block.minecraft.gold_ore": "Joldärz",
  "block.minecraft.golden_dandelion": "Goldener Löwenzahn",
  "block.minecraft.granite": "Jranit",
  "block.minecraft.granite_slab": "Jranitstof",
  "block.minecraft.granite_stairs": "Jranittrapp",
  "block.minecraft.granite_wall": "Jranitmor",
  "block.minecraft.grass": "Jras",
  "block.minecraft.grass_block": "Jraasäd",
  "block.minecraft.gravel": "Kis",
  "block.minecraft.gray_banner": "Jrau Fahn",
  "block.minecraft.gray_bed": "Jrau Bett",
  "block.minecraft.gray_candle": "Jraue Käz",
  "block.minecraft.gray_candle_cake": "Kooche met jraue Kääz",
  "block.minecraft.gray_carpet": "Jraue Teppich",
  "block.minecraft.gray_concrete": "Jraue Betong",
  "block.minecraft.gray_concrete_powder": "Jraue Drüchbetong",
  "block.minecraft.gray_glazed_terracotta": "Jrau jlaseet Steinjot",
  "block.minecraft.gray_shulker_box": "Jrau Shulker-Keß",
  "block.minecraft.gray_stained_glass": "Jrau jefärv Jlas",
  "block.minecraft.gray_stained_glass_pane": "Jrau jefärv Jlasschiev",
  "block.minecraft.gray_terracotta": "Jrau Steinjot",
  "block.minecraft.gray_wool": "Jraue Woll",
  "block.minecraft.green_banner": "Jrön Fahn",
  "block.minecraft.green_bed": "Jrön Bett",
  "block.minecraft.green_candle": "Jröne Käz",
  "block.minecraft.green_candle_cake": "Kooche met jröne Kääz",
  "block.minecraft.green_carpet": "Jröne Teppich",
  "block.minecraft.green_concrete": "Jröne Betong",
  "block.minecraft.green_concrete_powder": "Jröne Drüchbetong",
  "block.minecraft.green_glazed_terracotta": "Jrön jlaseet Steinjot",
  "block.minecraft.green_shulker_box": "Jrön Shulker-Keß",
  "block.minecraft.green_stained_glass": "Jrön jefärv Jlas",
  "block.minecraft.green_stained_glass_pane": "Jrön jefärv Jlasschiev",
  "block.minecraft.green_terracotta": "Jrön Steinjot",
  "block.minecraft.green_wool": "Jröne Woll",
  "block.minecraft.grindstone": "Schliefstein",
  "block.minecraft.hanging_roots": "Hängende Wuzzele",
  "block.minecraft.hay_block": "Strühballe",
  "block.minecraft.heavy_core": "Schwerer Kern",
  "block.minecraft.heavy_weighted_pressure_plate": "Ieser Wäjeplaat",
  "block.minecraft.honey_block": "Honnichblock",
  "block.minecraft.honeycomb_block": "Honnichwoveblock",
  "block.minecraft.hopper": "Treechter",
  "block.minecraft.horn_coral": "Jeweihkorall",
  "block.minecraft.horn_coral_block": "Jeweihkoralleblock",
  "block.minecraft.horn_coral_fan": "Jeweihkorallefächer",
  "block.minecraft.horn_coral_wall_fan": "Jeweihkorallewandfächer",
  "block.minecraft.ice": "Ies",
  "block.minecraft.infested_chiseled_stone_bricks": "Befallene ziseleet Steinziejel",
  "block.minecraft.infested_cobblestone": "Befallene Brochstein",
  "block.minecraft.infested_cracked_stone_bricks": "Befallene jeresse Steinziejel",
  "block.minecraft.infested_deepslate": "Befallene Deefdenleie",
  "block.minecraft.infested_mossy_stone_bricks": "Befallene bemoste Steinziejel",
  "block.minecraft.infested_stone": "Befallene Stein",
  "block.minecraft.infested_stone_bricks": "Befallene Steinziejel",
  "block.minecraft.iron_bars": "Iesejidder",
  "block.minecraft.iron_block": "Iese",
  "block.minecraft.iron_chain": "Eisenkette",
  "block.minecraft.iron_door": "Iesedür",
  "block.minecraft.iron_ore": "Ieseärz",
  "block.minecraft.iron_trapdoor": "Iesetrappdür",
  "block.minecraft.jack_o_lantern": "Kürbislatän",
  "block.minecraft.jigsaw": "Pusselblock",
  "block.minecraft.jukebox": "Plaatespiller",
  "block.minecraft.jungle_button": "Tropeholzknopp",
  "block.minecraft.jungle_door": "Tropeholzdür",
  "block.minecraft.jungle_fence": "Tropeholzzong",
  "block.minecraft.jungle_fence_gate": "Tropeholzjadder",
  "block.minecraft.jungle_hanging_sign": "Tropenholzhängeschild",
  "block.minecraft.jungle_leaves": "Tropebaumlauv",
  "block.minecraft.jungle_log": "Tropestamm",
  "block.minecraft.jungle_planks": "Tropeholzbredder",
  "block.minecraft.jungle_pressure_plate": "Tropeholzdröckplaat",
  "block.minecraft.jungle_sapling": "Tropeböumche",
  "block.minecraft.jungle_shelf": "Tropenholzregal",
  "block.minecraft.jungle_sign": "Tropeholzscheld",
  "block.minecraft.jungle_slab": "Tropeholzstof",
  "block.minecraft.jungle_stairs": "Tropeholztrapp",
  "block.minecraft.jungle_trapdoor": "Tropeholztrappdür",
  "block.minecraft.jungle_wall_hanging_sign": "Tropenholzwandhängeschild",
  "block.minecraft.jungle_wall_sign": "Tropeholzwandscheld",
  "block.minecraft.jungle_wood": "Tropeholz",
  "block.minecraft.kelp": "Sietang",
  "block.minecraft.kelp_plant": "Sietangstang",
  "block.minecraft.ladder": "Leeder",
  "block.minecraft.lantern": "Latän",
  "block.minecraft.lapis_block": "Lapislazoliblock",
  "block.minecraft.lapis_ore": "Lapislazoliärz",
  "block.minecraft.large_amethyst_bud": "Jroß Ametüstknopp",
  "block.minecraft.large_fern": "Huhe Farre",
  "block.minecraft.lava": "Lava",
  "block.minecraft.lava_cauldron": "Lavabütt",
  "block.minecraft.leaf_litter": "Laubhaufen",
  "block.minecraft.lectern": "Lesepult",
  "block.minecraft.lever": "Hävvel",
  "block.minecraft.light": "Leech",
  "block.minecraft.light_blue_banner": "Hellblau Fahn",
  "block.minecraft.light_blue_bed": "Hellblau Bett",
  "block.minecraft.light_blue_candle": "Hellblaue Käz",
  "block.minecraft.light_blue_candle_cake": "Kooche met hellblaue Kääz",
  "block.minecraft.light_blue_carpet": "Hellblaue Teppich",
  "block.minecraft.light_blue_concrete": "Hellblaue Betong",
  "block.minecraft.light_blue_concrete_powder": "Hellblaue Drüchbetong",
  "block.minecraft.light_blue_glazed_terracotta": "Hellblau jlaseet Steinjot",
  "block.minecraft.light_blue_shulker_box": "Hellblaue Shulker-Keß",
  "block.minecraft.light_blue_stained_glass": "Hellblau jefärv Jlas",
  "block.minecraft.light_blue_stained_glass_pane": "Hellblau jefärv Jlasschiev",
  "block.minecraft.light_blue_terracotta": "Hellblau Steinjot",
  "block.minecraft.light_blue_wool": "Hellblaue Woll",
  "block.minecraft.light_gray_banner": "Helljrau Fahn",
  "block.minecraft.light_gray_bed": "Helljrau Bett",
  "block.minecraft.light_gray_candle": "Helljraue Käz",
  "block.minecraft.light_gray_candle_cake": "Kooche met helljraue Kääz",
  "block.minecraft.light_gray_carpet": "Helljraue Teppich",
  "block.minecraft.light_gray_concrete": "Helljraue Betong",
  "block.minecraft.light_gray_concrete_powder": "Helljraue Drüchbetong",
  "block.minecraft.light_gray_glazed_terracotta": "Helljrau jlaseet Steinjot",
  "block.minecraft.light_gray_shulker_box": "Helljrau Shulker-Keß",
  "block.minecraft.light_gray_stained_glass": "Helljrau jefärv Jlas",
  "block.minecraft.light_gray_stained_glass_pane": "Helljrau jefärv Jlasschiev",
  "block.minecraft.light_gray_terracotta": "Helljrau Steinjot",
  "block.minecraft.light_gray_wool": "Helljraue Woll",
  "block.minecraft.light_weighted_pressure_plate": "Joldene Wäjeplaat",
  "block.minecraft.lightning_rod": "Bletzafleiter",
  "block.minecraft.lilac": "Fleere",
  "block.minecraft.lily_of_the_valley": "Maijlöckche",
  "block.minecraft.lily_pad": "Sierusejröns",
  "block.minecraft.lime_banner": "Helljrön Fahn",
  "block.minecraft.lime_bed": "Helljrön Bett",
  "block.minecraft.lime_candle": "Helljröne Käz",
  "block.minecraft.lime_candle_cake": "Kooche met helljröne Kääz",
  "block.minecraft.lime_carpet": "Helljröne Teppich",
  "block.minecraft.lime_concrete": "Helljröne Betong",
  "block.minecraft.lime_concrete_powder": "Helljröne Drüchbetong",
  "block.minecraft.lime_glazed_terracotta": "Helljrön jlaseet Steinjot",
  "block.minecraft.lime_shulker_box": "Helljrön Shulker-Keß",
  "block.minecraft.lime_stained_glass": "Helljrön jefärv Jlas",
  "block.minecraft.lime_stained_glass_pane": "Helljrön jefärv Jlasschiev",
  "block.minecraft.lime_terracotta": "Helljrön Steinjot",
  "block.minecraft.lime_wool": "Helljröne Woll",
  "block.minecraft.lodestone": "Leitstein",
  "block.minecraft.loom": "Wevstohl",
  "block.minecraft.magenta_banner": "Majenta Fahn",
  "block.minecraft.magenta_bed": "Majenta Bett",
  "block.minecraft.magenta_candle": "Majenta Käz",
  "block.minecraft.magenta_candle_cake": "Kooche met majenta Kääz",
  "block.minecraft.magenta_carpet": "Majenta Teppich",
  "block.minecraft.magenta_concrete": "Majenta Betong",
  "block.minecraft.magenta_concrete_powder": "Majenta Drüchbetong",
  "block.minecraft.magenta_glazed_terracotta": "Majenta jlaseet Steinjot",
  "block.minecraft.magenta_shulker_box": "Majenta Shulker-Keß",
  "block.minecraft.magenta_stained_glass": "Majenta jefärv Jlas",
  "block.minecraft.magenta_stained_glass_pane": "Majenta jefärv Jlasschiev",
  "block.minecraft.magenta_terracotta": "Majenta Steinjot",
  "block.minecraft.magenta_wool": "Majenta Woll",
  "block.minecraft.magma_block": "Machma",
  "block.minecraft.mangrove_button": "Mangrovenholzknopf",
  "block.minecraft.mangrove_door": "Mangrovenholztür",
  "block.minecraft.mangrove_fence": "Mangrovenholzzaun",
  "block.minecraft.mangrove_fence_gate": "Mangrovenholzzauntor",
  "block.minecraft.mangrove_hanging_sign": "Mangrovenholzhängeschild",
  "block.minecraft.mangrove_leaves": "Mangrovenlaub",
  "block.minecraft.mangrove_log": "Mangrovenstamm",
  "block.minecraft.mangrove_planks": "Mangrovenholzbretter",
  "block.minecraft.mangrove_pressure_plate": "Mangrovenholzdruckplatte",
  "block.minecraft.mangrove_propagule": "Mangroven-Keimling",
  "block.minecraft.mangrove_roots": "Mangrovenwurzeln",
  "block.minecraft.mangrove_shelf": "Mangrovenholzregal",
  "block.minecraft.mangrove_sign": "Mangrovenholzschild",
  "block.minecraft.mangrove_slab": "Mangrovenholzstufe",
  "block.minecraft.mangrove_stairs": "Mangrovenholztreppe",
  "block.minecraft.mangrove_trapdoor": "Mangrovenholzfalltür",
  "block.minecraft.mangrove_wall_hanging_sign": "Mangrovenholzwandhängeschild",
  "block.minecraft.mangrove_wall_sign": "Mangrovenholzwandschild",
  "block.minecraft.mangrove_wood": "Mangrovenholz",
  "block.minecraft.medium_amethyst_bud": "Meddel Ametüstknopp",
  "block.minecraft.melon": "Melon",
  "block.minecraft.melon_stem": "Melonerank",
  "block.minecraft.moss_block": "Mosblock",
  "block.minecraft.moss_carpet": "Mosteppich",
  "block.minecraft.mossy_cobblestone": "Bemoste Brochstein",
  "block.minecraft.mossy_cobblestone_slab": "Bemoste Brochsteinstof",
  "block.minecraft.mossy_cobblestone_stairs": "Bemoste Brochsteintrapp",
  "block.minecraft.mossy_cobblestone_wall": "Bemoste Brochsteinmor",
  "block.minecraft.mossy_stone_brick_slab": "Bemoste Steinziejelstof",
  "block.minecraft.mossy_stone_brick_stairs": "Bemoste Steinziejeltrapp",
  "block.minecraft.mossy_stone_brick_wall": "Bemoste Steinziejelmor",
  "block.minecraft.mossy_stone_bricks": "Bemoste Steinziejel",
  "block.minecraft.moving_piston": "Bewäjende Block",
  "block.minecraft.mud": "Schlamm",
  "block.minecraft.mud_brick_slab": "Schlammziegelstufe",
  "block.minecraft.mud_brick_stairs": "Schlammziegeltreppe",
  "block.minecraft.mud_brick_wall": "Schlammziegelmauer",
  "block.minecraft.mud_bricks": "Schlammziegel",
  "block.minecraft.muddy_mangrove_roots": "Schlammige Mangrovenwurzeln",
  "block.minecraft.mushroom_stem": "Pelzstill",
  "block.minecraft.mycelium": "Pelzäd",
  "block.minecraft.nether_brick_fence": "Netherziejelzong",
  "block.minecraft.nether_brick_slab": "Netherziejelstof",
  "block.minecraft.nether_brick_stairs": "Netherziejeltrapp",
  "block.minecraft.nether_brick_wall": "Netherziejelmor",
  "block.minecraft.nether_bricks": "Netherziejel",
  "block.minecraft.nether_gold_ore": "Nether-Joldärz",
  "block.minecraft.nether_portal": "Netherpoaz",
  "block.minecraft.nether_quartz_ore": "Netherkwarzärz",
  "block.minecraft.nether_sprouts": "Nether-Sprosse",
  "block.minecraft.nether_wart": "Netherwaaze",
  "block.minecraft.nether_wart_block": "Netherwaazeblock",
  "block.minecraft.netherite_block": "Netheritblock",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Musikblock",
  "block.minecraft.oak_button": "Schwatzeescheholzknopp",
  "block.minecraft.oak_door": "Eescheholzdür",
  "block.minecraft.oak_fence": "Eescheholzzong",
  "block.minecraft.oak_fence_gate": "Eescheholzjadder",
  "block.minecraft.oak_hanging_sign": "Eichenholzhängeschild",
  "block.minecraft.oak_leaves": "Eeschelauv",
  "block.minecraft.oak_log": "Eeschestamm",
  "block.minecraft.oak_planks": "Eescheholzbredder",
  "block.minecraft.oak_pressure_plate": "Eescheholzdröckplaat",
  "block.minecraft.oak_sapling": "Eescheböumche",
  "block.minecraft.oak_shelf": "Eichenholzregal",
  "block.minecraft.oak_sign": "Eescheholzscheld",
  "block.minecraft.oak_slab": "Eescheholzstof",
  "block.minecraft.oak_stairs": "Eescheholztrapp",
  "block.minecraft.oak_trapdoor": "Eescheholztrappdür",
  "block.minecraft.oak_wall_hanging_sign": "Eichenholzwandhängeschild",
  "block.minecraft.oak_wall_sign": "Eescheholzwandscheld",
  "block.minecraft.oak_wood": "Eescheholz",
  "block.minecraft.observer": "Lorer",
  "block.minecraft.obsidian": "Obssidijan",
  "block.minecraft.ochre_froglight": "Ockernes Froschlicht",
  "block.minecraft.ominous_banner": "Ömenös Fahn",
  "block.minecraft.open_eyeblossom": "Geöffnete Augenblüte",
  "block.minecraft.orange_banner": "Orangsch Fahn",
  "block.minecraft.orange_bed": "Orangsch Bett",
  "block.minecraft.orange_candle": "Orangsche Käz",
  "block.minecraft.orange_candle_cake": "Kooche met orangsche Kääz",
  "block.minecraft.orange_carpet": "Orangsche Teppich",
  "block.minecraft.orange_concrete": "Orangsche Betong",
  "block.minecraft.orange_concrete_powder": "Orangsche Drüchbetong",
  "block.minecraft.orange_glazed_terracotta": "Orangsch jlaseet Steinjot",
  "block.minecraft.orange_shulker_box": "Orangsch Shulker-Keß",
  "block.minecraft.orange_stained_glass": "Orangsch jefärv Jlas",
  "block.minecraft.orange_stained_glass_pane": "Orangsch jefärv Jlasschiev",
  "block.minecraft.orange_terracotta": "Orangsch Steinjot",
  "block.minecraft.orange_tulip": "Orangsch Tulp",
  "block.minecraft.orange_wool": "Orangsche Woll",
  "block.minecraft.oxeye_daisy": "Marjerit",
  "block.minecraft.oxidized_chiseled_copper": "Oxidierter gemeißelter Kupferblock",
  "block.minecraft.oxidized_copper": "Anjelaufe Koffer",
  "block.minecraft.oxidized_copper_bars": "Oxidiertes Kupfergitter",
  "block.minecraft.oxidized_copper_bulb": "Oxidierte Kupferleuchte",
  "block.minecraft.oxidized_copper_chain": "Oxidierte Kupferkette",
  "block.minecraft.oxidized_copper_chest": "Oxidierte Kupfertruhe",
  "block.minecraft.oxidized_copper_door": "Oxidierte Kupfertür",
  "block.minecraft.oxidized_copper_golem_statue": "Oxidierte Kupfergolemstatue",
  "block.minecraft.oxidized_copper_grate": "Oxidierter Kupferrost",
  "block.minecraft.oxidized_copper_lantern": "Oxidierte Kupferlaterne",
  "block.minecraft.oxidized_copper_trapdoor": "Oxidierte Kupferfalltür",
  "block.minecraft.oxidized_cut_copper": "Rüste schnigge Kofferblock",
  "block.minecraft.oxidized_cut_copper_slab": "Rüste schnigge Kofferstof",
  "block.minecraft.oxidized_cut_copper_stairs": "Rüste schnigge Koffertrapp",
  "block.minecraft.oxidized_lightning_rod": "Oxidierter Blitzableiter",
  "block.minecraft.packed_ice": "Packies",
  "block.minecraft.packed_mud": "Fester Schlamm",
  "block.minecraft.pale_hanging_moss": "Hängendes Blassmoos",
  "block.minecraft.pale_moss_block": "Blassmoosblock",
  "block.minecraft.pale_moss_carpet": "Blassmoosteppich",
  "block.minecraft.pale_oak_button": "Blasseichenholzknopf",
  "block.minecraft.pale_oak_door": "Blasseichenholztür",
  "block.minecraft.pale_oak_fence": "Blasseichenholzzaun",
  "block.minecraft.pale_oak_fence_gate": "Blasseichenholzzauntor",
  "block.minecraft.pale_oak_hanging_sign": "Blasseichenholzhängeschild",
  "block.minecraft.pale_oak_leaves": "Blasseichenlaub",
  "block.minecraft.pale_oak_log": "Blasseichenstamm",
  "block.minecraft.pale_oak_planks": "Blasseichenholzbretter",
  "block.minecraft.pale_oak_pressure_plate": "Blasseichenholzdruckplatte",
  "block.minecraft.pale_oak_sapling": "Blasseichensetzling",
  "block.minecraft.pale_oak_shelf": "Blasseichenholzregal",
  "block.minecraft.pale_oak_sign": "Blasseichenholzschild",
  "block.minecraft.pale_oak_slab": "Blasseichenholzstufe",
  "block.minecraft.pale_oak_stairs": "Blasseichenholztreppe",
  "block.minecraft.pale_oak_trapdoor": "Blasseichenholzfalltür",
  "block.minecraft.pale_oak_wall_hanging_sign": "Blasseichenholzwandhängeschild",
  "block.minecraft.pale_oak_wall_sign": "Blasseichenholzwandschild",
  "block.minecraft.pale_oak_wood": "Blasseichenholz",
  "block.minecraft.pearlescent_froglight": "Perlmutternes Froschlicht",
  "block.minecraft.peony": "Pingsrus",
  "block.minecraft.petrified_oak_slab": "Versteinerte Eescheholzstof",
  "block.minecraft.piglin_head": "Piglinkopf",
  "block.minecraft.piglin_wall_head": "Piglin-Wandkopf",
  "block.minecraft.pink_banner": "Rusa Fahn",
  "block.minecraft.pink_bed": "Rusa Bett",
  "block.minecraft.pink_candle": "Rusa Käz",
  "block.minecraft.pink_candle_cake": "Kooche met rusa Kääz",
  "block.minecraft.pink_carpet": "Rusa Teppich",
  "block.minecraft.pink_concrete": "Rusa Betong",
  "block.minecraft.pink_concrete_powder": "Rusa Drüchbetong",
  "block.minecraft.pink_glazed_terracotta": "Rusa jlaseet Steinjot",
  "block.minecraft.pink_petals": "Rosa Blütenblätter",
  "block.minecraft.pink_shulker_box": "Rusa Shulker-Keß",
  "block.minecraft.pink_stained_glass": "Rusa jefärv Jlas",
  "block.minecraft.pink_stained_glass_pane": "Rusa jefärv Jlasschiev",
  "block.minecraft.pink_terracotta": "Rusa Steinjot",
  "block.minecraft.pink_tulip": "Rusa Tulp",
  "block.minecraft.pink_wool": "Rusa Woll",
  "block.minecraft.piston": "Kolve",
  "block.minecraft.piston_head": "Kolvekopp",
  "block.minecraft.pitcher_crop": "Kannenpflanzentrieb",
  "block.minecraft.pitcher_plant": "Kannenpflanze",
  "block.minecraft.player_head": "Spillerkopp",
  "block.minecraft.player_head.named": "Däm %s singe Kopp",
  "block.minecraft.player_wall_head": "Spillerwandkopp",
  "block.minecraft.podzol": "Jrauäd",
  "block.minecraft.pointed_dripstone": "Spitzer Tropfstein",
  "block.minecraft.polished_andesite": "Poleete Andesit",
  "block.minecraft.polished_andesite_slab": "Poleete Andesitstof",
  "block.minecraft.polished_andesite_stairs": "Poleete Andesittrapp",
  "block.minecraft.polished_basalt": "Poleete Basalt",
  "block.minecraft.polished_blackstone": "Poleete Schwatzstein",
  "block.minecraft.polished_blackstone_brick_slab": "Poleete Schwatzsteinziejelstof",
  "block.minecraft.polished_blackstone_brick_stairs": "Poleete Schwatzsteinziejeltrapp",
  "block.minecraft.polished_blackstone_brick_wall": "Poleete Schwatzsteinziejelmor",
  "block.minecraft.polished_blackstone_bricks": "Poleete Schwatzsteinziejel",
  "block.minecraft.polished_blackstone_button": "Poleete Schwatzsteinknop",
  "block.minecraft.polished_blackstone_pressure_plate": "Poleete Schwatzsteindröckplaat",
  "block.minecraft.polished_blackstone_slab": "Poleete Schwatzsteinstof",
  "block.minecraft.polished_blackstone_stairs": "Poleete Schwatzsteintrapp",
  "block.minecraft.polished_blackstone_wall": "Poleete Schwatzsteinmor",
  "block.minecraft.polished_deepslate": "Poleete Deefdenleie",
  "block.minecraft.polished_deepslate_slab": "Poleete Deefdenleieplaat",
  "block.minecraft.polished_deepslate_stairs": "Poleete Deefdenleietrapp",
  "block.minecraft.polished_deepslate_wall": "Poleete Deefdenleiemor",
  "block.minecraft.polished_diorite": "Poleete Dijorit",
  "block.minecraft.polished_diorite_slab": "Poleete Dijoritstof",
  "block.minecraft.polished_diorite_stairs": "Poleete Dijorittrapp",
  "block.minecraft.polished_granite": "Poleete Jranit",
  "block.minecraft.polished_granite_slab": "Poleete Jranitstof",
  "block.minecraft.polished_granite_stairs": "Poleete Jranittrapp",
  "block.minecraft.polished_tuff": "Polierter Tuffstein",
  "block.minecraft.polished_tuff_slab": "Polierte Tuffsteinstufe",
  "block.minecraft.polished_tuff_stairs": "Polierte Tuffsteintreppe",
  "block.minecraft.polished_tuff_wall": "Polierte Tuffsteinmauer",
  "block.minecraft.poppy": "Klatschrus",
  "block.minecraft.potatoes": "Ädäppel",
  "block.minecraft.potted_acacia_sapling": "Enjepottet Akazijeböumche",
  "block.minecraft.potted_allium": "Enjepottete Öllisch",
  "block.minecraft.potted_azalea_bush": "Enjepottete Azalee",
  "block.minecraft.potted_azure_bluet": "Enjepottet Postelingstähnche",
  "block.minecraft.potted_bamboo": "Enjepottet Bambus",
  "block.minecraft.potted_birch_sapling": "Enjepottet Birkeböumche",
  "block.minecraft.potted_blue_orchid": "Enjepottete blaue Orschidee",
  "block.minecraft.potted_brown_mushroom": "Enjepottete brunge Pelz",
  "block.minecraft.potted_cactus": "Enjepottete Kaktus",
  "block.minecraft.potted_cherry_sapling": "Eingetopfter Kirschsetzling",
  "block.minecraft.potted_closed_eyeblossom": "Eingetopfte geschlossene Augenblüte",
  "block.minecraft.potted_cornflower": "Enjepottete Kornblom",
  "block.minecraft.potted_crimson_fungus": "Enjepottet Karmesinnpelz",
  "block.minecraft.potted_crimson_roots": "Enjepottet Karmesinnwuzzele",
  "block.minecraft.potted_dandelion": "Enjepottete Ketteblom",
  "block.minecraft.potted_dark_oak_sapling": "Enjepottet Schwatzeescheböumche",
  "block.minecraft.potted_dead_bush": "Enjepottete dude Struch",
  "block.minecraft.potted_fern": "Enjepottet Farre",
  "block.minecraft.potted_flowering_azalea_bush": "Enjepottete blöhende Azalee",
  "block.minecraft.potted_golden_dandelion": "Eingetopfter goldener Löwenzahn",
  "block.minecraft.potted_jungle_sapling": "Enjepottet Tropeböumche",
  "block.minecraft.potted_lily_of_the_valley": "Enjepottet Maijlöckche",
  "block.minecraft.potted_mangrove_propagule": "Eingetopfter Mangroven-Keimling",
  "block.minecraft.potted_oak_sapling": "Enjepottet Eescheböumche",
  "block.minecraft.potted_open_eyeblossom": "Eingetopfte geöffnete Augenblüte",
  "block.minecraft.potted_orange_tulip": "Enjepottete orangsch Tulp",
  "block.minecraft.potted_oxeye_daisy": "Enjepottete Marjerit",
  "block.minecraft.potted_pale_oak_sapling": "Eingetopfter Blasseichensetzling",
  "block.minecraft.potted_pink_tulip": "Enjepottete rusa Tulp",
  "block.minecraft.potted_poppy": "Enjepottete Klatschrus",
  "block.minecraft.potted_red_mushroom": "Enjepottete rude Pelz",
  "block.minecraft.potted_red_tulip": "Enjepottete rude Tulp",
  "block.minecraft.potted_spruce_sapling": "Enjepottet Danneböumche",
  "block.minecraft.potted_torchflower": "Eingetopfte Fackellilie",
  "block.minecraft.potted_warped_fungus": "Enjepottet Jeckepelz",
  "block.minecraft.potted_warped_roots": "Enjepottet Jeckewuzzele",
  "block.minecraft.potted_white_tulip": "Enjepottete wieße Tulp",
  "block.minecraft.potted_wither_rose": "Enjepottete Witherrus",
  "block.minecraft.powder_snow": "Polverschnie",
  "block.minecraft.powder_snow_cauldron": "Polverschniebütt",
  "block.minecraft.powered_rail": "Andrevsschinne",
  "block.minecraft.prismarine": "Prismarin",
  "block.minecraft.prismarine_brick_slab": "Prismarinziejelstof",
  "block.minecraft.prismarine_brick_stairs": "Prismarinziejeltrapp",
  "block.minecraft.prismarine_bricks": "Prismarinziejel",
  "block.minecraft.prismarine_slab": "Prismarinstof",
  "block.minecraft.prismarine_stairs": "Prismarintrapp",
  "block.minecraft.prismarine_wall": "Prismarinmor",
  "block.minecraft.pumpkin": "Kürbis",
  "block.minecraft.pumpkin_stem": "Kürbisrank",
  "block.minecraft.purple_banner": "Vijelett Fahn",
  "block.minecraft.purple_bed": "Vijelett Bett",
  "block.minecraft.purple_candle": "Vijelette Käz",
  "block.minecraft.purple_candle_cake": "Kooche met vijelette Kääz",
  "block.minecraft.purple_carpet": "Vijelette Teppich",
  "block.minecraft.purple_concrete": "Vijelette Betong",
  "block.minecraft.purple_concrete_powder": "Vijelette Drüchbetong",
  "block.minecraft.purple_glazed_terracotta": "Vijelett jlaseet Steinjot",
  "block.minecraft.purple_shulker_box": "Vijelette Shulker-Keß",
  "block.minecraft.purple_stained_glass": "Vijelett jefärv Jlas",
  "block.minecraft.purple_stained_glass_pane": "Vijelett jefärv Jlasschiev",
  "block.minecraft.purple_terracotta": "Vijelett Steinjot",
  "block.minecraft.purple_wool": "Vijelette Woll",
  "block.minecraft.purpur_block": "Purpur",
  "block.minecraft.purpur_pillar": "Purpursül",
  "block.minecraft.purpur_slab": "Purpurstof",
  "block.minecraft.purpur_stairs": "Purpurtrapp",
  "block.minecraft.quartz_block": "Kwarz",
  "block.minecraft.quartz_bricks": "Kwarzziejel",
  "block.minecraft.quartz_pillar": "Kwarzsül",
  "block.minecraft.quartz_slab": "Kwarzstof",
  "block.minecraft.quartz_stairs": "Kwarztrapp",
  "block.minecraft.rail": "Schinne",
  "block.minecraft.raw_copper_block": "Rühkofferblock",
  "block.minecraft.raw_gold_block": "Rühjoldblock",
  "block.minecraft.raw_iron_block": "Rühieseblock",
  "block.minecraft.red_banner": "Rut Fahn",
  "block.minecraft.red_bed": "Rut Bett",
  "block.minecraft.red_candle": "Rude Käz",
  "block.minecraft.red_candle_cake": "Kooche met rude Kääz",
  "block.minecraft.red_carpet": "Rude Teppich",
  "block.minecraft.red_concrete": "Rude Betong",
  "block.minecraft.red_concrete_powder": "Rude Drüchbetong",
  "block.minecraft.red_glazed_terracotta": "Rut jlaseet Steinjot",
  "block.minecraft.red_mushroom": "Rude Pelz",
  "block.minecraft.red_mushroom_block": "Rude Pelz",
  "block.minecraft.red_nether_brick_slab": "Rude Netherziejelstof",
  "block.minecraft.red_nether_brick_stairs": "Rude Netherziejeltrapp",
  "block.minecraft.red_nether_brick_wall": "Rude Netherziejelmor",
  "block.minecraft.red_nether_bricks": "Rude Netherziejel",
  "block.minecraft.red_sand": "Rude Sand",
  "block.minecraft.red_sandstone": "Rude Sandstein",
  "block.minecraft.red_sandstone_slab": "Rut Sandsteinstof",
  "block.minecraft.red_sandstone_stairs": "Rut Sandsteintrapp",
  "block.minecraft.red_sandstone_wall": "Rut Sandsteinmor",
  "block.minecraft.red_shulker_box": "Rut Shulker-Keß",
  "block.minecraft.red_stained_glass": "Rut jefärv Jlas",
  "block.minecraft.red_stained_glass_pane": "Rut jefärv Jlasschiev",
  "block.minecraft.red_terracotta": "Rut Steinjot",
  "block.minecraft.red_tulip": "Rut Tulp",
  "block.minecraft.red_wool": "Rude Woll",
  "block.minecraft.redstone_block": "Redstone-Block",
  "block.minecraft.redstone_lamp": "Redstone-Lamp",
  "block.minecraft.redstone_ore": "Redstone-Ärz",
  "block.minecraft.redstone_torch": "Redstone-Tootsch",
  "block.minecraft.redstone_wall_torch": "Redstone-Wandtootsch",
  "block.minecraft.redstone_wire": "Redstone-Droht",
  "block.minecraft.reinforced_deepslate": "Verstärkter Tiefenschiefer",
  "block.minecraft.repeater": "Redstone-Verstärke",
  "block.minecraft.repeating_command_block": "Widderhol-Befellsblock",
  "block.minecraft.resin_block": "Harzblock",
  "block.minecraft.resin_brick_slab": "Harzziegelstufe",
  "block.minecraft.resin_brick_stairs": "Harzziegeltreppe",
  "block.minecraft.resin_brick_wall": "Harzziegelmauer",
  "block.minecraft.resin_bricks": "Harzziegel",
  "block.minecraft.resin_clump": "Harzklumpen",
  "block.minecraft.respawn_anchor": "Sieleanker",
  "block.minecraft.rooted_dirt": "Wuzzeläd",
  "block.minecraft.rose_bush": "Rusestruch",
  "block.minecraft.sand": "Sand",
  "block.minecraft.sandstone": "Sandstein",
  "block.minecraft.sandstone_slab": "Sandsteinstof",
  "block.minecraft.sandstone_stairs": "Sandsteintrapp",
  "block.minecraft.sandstone_wall": "Sandsteinmor",
  "block.minecraft.scaffolding": "Jerös",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Sculk-Katalysator",
  "block.minecraft.sculk_sensor": "Sculk-Sensor",
  "block.minecraft.sculk_shrieker": "Sculk-Kreischer",
  "block.minecraft.sculk_vein": "Sculk-Ader",
  "block.minecraft.sea_lantern": "Sielatän",
  "block.minecraft.sea_pickle": "Meerjurk",
  "block.minecraft.seagrass": "Siejrass",
  "block.minecraft.set_spawn": "Widdereinstiechsplaatz jesetz",
  "block.minecraft.short_dry_grass": "Niedriges Trockengras",
  "block.minecraft.short_grass": "Niedriges Gras",
  "block.minecraft.shroomlight": "Pelzleech",
  "block.minecraft.shulker_box": "Shulker-Keß",
  "block.minecraft.skeleton_skull": "Dudekopp",
  "block.minecraft.skeleton_wall_skull": "Wand-Dudekopp",
  "block.minecraft.slime_block": "Schliem",
  "block.minecraft.small_amethyst_bud": "Klein Ametüstknopp",
  "block.minecraft.small_dripleaf": "Kleines Tropfblatt",
  "block.minecraft.smithing_table": "Schmiddedesch",
  "block.minecraft.smoker": "Räucherovve",
  "block.minecraft.smooth_basalt": "Jlatte Basalt",
  "block.minecraft.smooth_quartz": "Jlatte Kwarzblock",
  "block.minecraft.smooth_quartz_slab": "Jlatte Kwarzstof",
  "block.minecraft.smooth_quartz_stairs": "Jlatte Kwarztrapp",
  "block.minecraft.smooth_red_sandstone": "Jlatte rude Sandstein",
  "block.minecraft.smooth_red_sandstone_slab": "Jlatte rude Sandsteinstof",
  "block.minecraft.smooth_red_sandstone_stairs": "Jlatte rude Sandsteintrapp",
  "block.minecraft.smooth_sandstone": "Jlatte Sandstein",
  "block.minecraft.smooth_sandstone_slab": "Jlatte Sandsteinstof",
  "block.minecraft.smooth_sandstone_stairs": "Jlatte Steintrapp",
  "block.minecraft.smooth_stone": "Jlatte Stein",
  "block.minecraft.smooth_stone_slab": "Jlatte Steinstof",
  "block.minecraft.sniffer_egg": "Schnüffler-Ei",
  "block.minecraft.snow": "Schnie",
  "block.minecraft.snow_block": "Schnieblock",
  "block.minecraft.soul_campfire": "Sieleförstell",
  "block.minecraft.soul_fire": "Sieleför",
  "block.minecraft.soul_lantern": "Sielelatän",
  "block.minecraft.soul_sand": "Sielesand",
  "block.minecraft.soul_soil": "Sieleäd",
  "block.minecraft.soul_torch": "Sieletootsch",
  "block.minecraft.soul_wall_torch": "Sielewandtootsch",
  "block.minecraft.spawn.not_valid": "Do häs kein Bett un keine opjeladene Sieleanker, udder dinge Widdereinstiechsplaatz wood blockeet",
  "block.minecraft.spawner": "Spawner",
  "block.minecraft.spawner.desc1": "Benutze Spawn‐Ei:",
  "block.minecraft.spawner.desc2": "Legt Kreaturentyp fest",
  "block.minecraft.sponge": "Schwamm",
  "block.minecraft.spore_blossom": "Sporenblüte",
  "block.minecraft.spruce_button": "Danneholzknopp",
  "block.minecraft.spruce_door": "Danneholzdür",
  "block.minecraft.spruce_fence": "Danneholzzong",
  "block.minecraft.spruce_fence_gate": "Danneholzjadder",
  "block.minecraft.spruce_hanging_sign": "Fichtenholzhängeschild",
  "block.minecraft.spruce_leaves": "Dannenole",
  "block.minecraft.spruce_log": "Dannestamm",
  "block.minecraft.spruce_planks": "Danneholzbredder",
  "block.minecraft.spruce_pressure_plate": "Dannedröckplaat",
  "block.minecraft.spruce_sapling": "Danneböumche",
  "block.minecraft.spruce_shelf": "Fichtenholzregal",
  "block.minecraft.spruce_sign": "Danneholzscheld",
  "block.minecraft.spruce_slab": "Danneholzstof",
  "block.minecraft.spruce_stairs": "Danneholztrapp",
  "block.minecraft.spruce_trapdoor": "Danneholztrappdür",
  "block.minecraft.spruce_wall_hanging_sign": "Fichtenholzwandhängeschild",
  "block.minecraft.spruce_wall_sign": "Danneholzwandscheld",
  "block.minecraft.spruce_wood": "Danneholz",
  "block.minecraft.sticky_piston": "Klävkolve",
  "block.minecraft.stone": "Stein",
  "block.minecraft.stone_brick_slab": "Steinziejelstof",
  "block.minecraft.stone_brick_stairs": "Steinziejeltrapp",
  "block.minecraft.stone_brick_wall": "Steinziejelmor",
  "block.minecraft.stone_bricks": "Steinziejel",
  "block.minecraft.stone_button": "Steinknopp",
  "block.minecraft.stone_pressure_plate": "Steindröckplaat",
  "block.minecraft.stone_slab": "Steinstof",
  "block.minecraft.stone_stairs": "Steintrapp",
  "block.minecraft.stonecutter": "Steinsäch",
  "block.minecraft.stripped_acacia_log": "Jeschälte Akazijestamm",
  "block.minecraft.stripped_acacia_wood": "Jeschält Akazijeholz",
  "block.minecraft.stripped_bamboo_block": "Geschälter Bambusblock",
  "block.minecraft.stripped_birch_log": "Jeschälte Birkestamm",
  "block.minecraft.stripped_birch_wood": "Jeschält Birkeholz",
  "block.minecraft.stripped_cherry_log": "Entrindeter Kirschstamm",
  "block.minecraft.stripped_cherry_wood": "Entrindetes Kirschholz",
  "block.minecraft.stripped_crimson_hyphae": "Jeschälte Karmesinnhüfe",
  "block.minecraft.stripped_crimson_stem": "Jeschälte Karmesinnstill",
  "block.minecraft.stripped_dark_oak_log": "Jeschälte Schwatzeeschestamm",
  "block.minecraft.stripped_dark_oak_wood": "Jeschält Schwatzeescheholz",
  "block.minecraft.stripped_jungle_log": "Jeschälte Tropeholzstamm",
  "block.minecraft.stripped_jungle_wood": "Jeschält Tropeholz",
  "block.minecraft.stripped_mangrove_log": "Entrindeter Mangrovenstamm",
  "block.minecraft.stripped_mangrove_wood": "Entrindetes Mangrovenholz",
  "block.minecraft.stripped_oak_log": "Jeschälte Eeschestamm",
  "block.minecraft.stripped_oak_wood": "Jeschält Eescheholz",
  "block.minecraft.stripped_pale_oak_log": "Entrindeter Blasseichenstamm",
  "block.minecraft.stripped_pale_oak_wood": "Entrindetes Blasseichenholz",
  "block.minecraft.stripped_spruce_log": "Jeschälte Dannestamm",
  "block.minecraft.stripped_spruce_wood": "Jeschält Danneholz",
  "block.minecraft.stripped_warped_hyphae": "Jeschälte Jeckehüfe",
  "block.minecraft.stripped_warped_stem": "Jeschälte Jeckestill",
  "block.minecraft.structure_block": "Konstrukzijonsblock",
  "block.minecraft.structure_void": "Konstrukzijonsleddischkeit",
  "block.minecraft.sugar_cane": "Zuckerrühr",
  "block.minecraft.sunflower": "Sunneblom",
  "block.minecraft.suspicious_gravel": "Seltsamer Kies",
  "block.minecraft.suspicious_sand": "Seltsamer Sand",
  "block.minecraft.sweet_berry_bush": "Sößberestruch",
  "block.minecraft.tall_dry_grass": "Hohes Trockengras",
  "block.minecraft.tall_grass": "Huh Jras",
  "block.minecraft.tall_seagrass": "Huh Siejrass",
  "block.minecraft.target": "Zillblock",
  "block.minecraft.terracotta": "Steinjot",
  "block.minecraft.test_block": "Testblock",
  "block.minecraft.test_instance_block": "Testinstanzblock",
  "block.minecraft.tinted_glass": "Jetönt Jlas",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "TNT‐Explosionen sind deaktiviert",
  "block.minecraft.torch": "Tootsch",
  "block.minecraft.torchflower": "Fackellilie",
  "block.minecraft.torchflower_crop": "Fackellilienpflanze",
  "block.minecraft.trapped_chest": "Trickkeß",
  "block.minecraft.trial_spawner": "Prüfungs-Spawner",
  "block.minecraft.tripwire": "Struchelsdroht",
  "block.minecraft.tripwire_hook": "Hoke",
  "block.minecraft.tube_coral": "Orjelkorall",
  "block.minecraft.tube_coral_block": "Orjelkoralleblock",
  "block.minecraft.tube_coral_fan": "Orjelkorallefächer",
  "block.minecraft.tube_coral_wall_fan": "Orjelkorallewandfächer",
  "block.minecraft.tuff": "Tuff",
  "block.minecraft.tuff_brick_slab": "Tuffsteinziegelstufe",
  "block.minecraft.tuff_brick_stairs": "Tuffsteinziegeltreppe",
  "block.minecraft.tuff_brick_wall": "Tuffsteinziegelmauer",
  "block.minecraft.tuff_bricks": "Tuffsteinziegel",
  "block.minecraft.tuff_slab": "Tuffsteinstufe",
  "block.minecraft.tuff_stairs": "Tuffsteintreppe",
  "block.minecraft.tuff_wall": "Tuffsteinmauer",
  "block.minecraft.turtle_egg": "Scheldkraate-Ei",
  "block.minecraft.twisting_vines": "Zwirvelranke",
  "block.minecraft.twisting_vines_plant": "Zwirvelrankeplant",
  "block.minecraft.vault": "Tresor",
  "block.minecraft.verdant_froglight": "Junggrünes Froschlicht",
  "block.minecraft.vine": "Ranke",
  "block.minecraft.void_air": "Ledijjeluff",
  "block.minecraft.wall_torch": "Wandtootsch",
  "block.minecraft.warped_button": "Jeckeknopp",
  "block.minecraft.warped_door": "Jeckedür",
  "block.minecraft.warped_fence": "Jeckezong",
  "block.minecraft.warped_fence_gate": "Jeckejadder",
  "block.minecraft.warped_fungus": "Jeckepelz",
  "block.minecraft.warped_hanging_sign": "Wirrhängeschild",
  "block.minecraft.warped_hyphae": "Jeckehüfe",
  "block.minecraft.warped_nylium": "Jecke-Nülliöm",
  "block.minecraft.warped_planks": "Jeckebredder",
  "block.minecraft.warped_pressure_plate": "Jeckedröckplaat",
  "block.minecraft.warped_roots": "Jeckewuzzele",
  "block.minecraft.warped_shelf": "Wirrregal",
  "block.minecraft.warped_sign": "Jeckescheld",
  "block.minecraft.warped_slab": "Jeckestof",
  "block.minecraft.warped_stairs": "Jecketrapp",
  "block.minecraft.warped_stem": "Jeckestill",
  "block.minecraft.warped_trapdoor": "Jecketrappdür",
  "block.minecraft.warped_wall_hanging_sign": "Wirrwandhängeschild",
  "block.minecraft.warped_wall_sign": "Jeckewandscheld",
  "block.minecraft.warped_wart_block": "Jeckewaazeblock",
  "block.minecraft.water": "Wasser",
  "block.minecraft.water_cauldron": "Wasserbütt",
  "block.minecraft.waxed_chiseled_copper": "Gewachster gemeißelter Kupferblock",
  "block.minecraft.waxed_copper_bars": "Gewachstes Kupfergitter",
  "block.minecraft.waxed_copper_block": "Jewahße Kofferblock",
  "block.minecraft.waxed_copper_bulb": "Gewachste Kupferleuchte",
  "block.minecraft.waxed_copper_chain": "Gewachste Kupferkette",
  "block.minecraft.waxed_copper_chest": "Gewachste Kupfertruhe",
  "block.minecraft.waxed_copper_door": "Gewachste Kupfertür",
  "block.minecraft.waxed_copper_golem_statue": "Gewachste Kupfergolemstatue",
  "block.minecraft.waxed_copper_grate": "Gewachster Kupferrost",
  "block.minecraft.waxed_copper_lantern": "Gewachste Kupferlaterne",
  "block.minecraft.waxed_copper_trapdoor": "Gewachste Kupferfalltür",
  "block.minecraft.waxed_cut_copper": "Jewahße schnigge Kofferblock",
  "block.minecraft.waxed_cut_copper_slab": "Jewahße schnigge Kofferstof",
  "block.minecraft.waxed_cut_copper_stairs": "Jewahße schnigge Koffertrapp",
  "block.minecraft.waxed_exposed_chiseled_copper": "Gewachster angelaufener gemeißelter Kupferblock",
  "block.minecraft.waxed_exposed_copper": "Jewahße blänkiche Kofferblock",
  "block.minecraft.waxed_exposed_copper_bars": "Gewachstes angelaufenes Kupfergitter",
  "block.minecraft.waxed_exposed_copper_bulb": "Gewachste angelaufene Kupferleuchte",
  "block.minecraft.waxed_exposed_copper_chain": "Gewachste angelaufene Kupferkette",
  "block.minecraft.waxed_exposed_copper_chest": "Gewachste angelaufene Kupfertruhe",
  "block.minecraft.waxed_exposed_copper_door": "Gewachste angelaufene Kupfertür",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Gewachste angelaufene Kupfergolemstatue",
  "block.minecraft.waxed_exposed_copper_grate": "Gewachster angelaufener Kupferrost",
  "block.minecraft.waxed_exposed_copper_lantern": "Gewachste angelaufene Kupferlaterne",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Gewachste angelaufene Kupferfalltür",
  "block.minecraft.waxed_exposed_cut_copper": "Jewahße blänkiche schnigge Kofferblock",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Jewahße blänkiche schnigge Kofferstof",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Jewahße blänkiche schnigge Koffertrapp",
  "block.minecraft.waxed_exposed_lightning_rod": "Gewachster angelaufener Blitzableiter",
  "block.minecraft.waxed_lightning_rod": "Gewachster Blitzableiter",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Gewachster oxidierter gemeißelter Kupferblock",
  "block.minecraft.waxed_oxidized_copper": "Jewahße roste Kofferblock",
  "block.minecraft.waxed_oxidized_copper_bars": "Gewachstes oxidiertes Kupfergitter",
  "block.minecraft.waxed_oxidized_copper_bulb": "Gewachste oxidierte Kupferleuchte",
  "block.minecraft.waxed_oxidized_copper_chain": "Gewachste oxidierte Kupferkette",
  "block.minecraft.waxed_oxidized_copper_chest": "Gewachste oxidierte Kupfertruhe",
  "block.minecraft.waxed_oxidized_copper_door": "Gewachste oxidierte Kupfertür",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Gewachste oxidierte Kupfergolemstatue",
  "block.minecraft.waxed_oxidized_copper_grate": "Gewachster oxidierter Kupferrost",
  "block.minecraft.waxed_oxidized_copper_lantern": "Gewachste oxidierte Kupferlaterne",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Gewachste oxidierte Kupferfalltür",
  "block.minecraft.waxed_oxidized_cut_copper": "Jewahße rüste schnigge Kofferblock",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Jewahße rüste schnigge Kofferstof",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Jewahße rüste schnigge Koffertrapp",
  "block.minecraft.waxed_oxidized_lightning_rod": "Gewachster oxidierter Blitzableiter",
  "block.minecraft.waxed_weathered_chiseled_copper": "Gewachster verwitterter gemeißelter Kupferblock",
  "block.minecraft.waxed_weathered_copper": "Jewahße weddere Kofferblock",
  "block.minecraft.waxed_weathered_copper_bars": "Gewachstes verwittertes Kupfergitter",
  "block.minecraft.waxed_weathered_copper_bulb": "Gewachste verwitterte Kupferleuchte",
  "block.minecraft.waxed_weathered_copper_chain": "Gewachste verwitterte Kupferkette",
  "block.minecraft.waxed_weathered_copper_chest": "Gewachste verwitterte Kupfertruhe",
  "block.minecraft.waxed_weathered_copper_door": "Gewachste verwitterte Kupfertür",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Gewachste verwitterte Kupfergolemstatue",
  "block.minecraft.waxed_weathered_copper_grate": "Gewachster verwitterter Kupferrost",
  "block.minecraft.waxed_weathered_copper_lantern": "Gewachste verwitterte Kupferlaterne",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Gewachste verwitterte Kupferfalltür",
  "block.minecraft.waxed_weathered_cut_copper": "Jewahße weddere schnigge Kofferblock",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Jewahße weddere schnigge Kofferstof",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Jewahße weddere schnigge Koffertrapp",
  "block.minecraft.waxed_weathered_lightning_rod": "Gewachster verwitterter Blitzableiter",
  "block.minecraft.weathered_chiseled_copper": "Verwitterter gemeißelter Kupferblock",
  "block.minecraft.weathered_copper": "Weddere Kofferblock",
  "block.minecraft.weathered_copper_bars": "Verwittertes Kupfergitter",
  "block.minecraft.weathered_copper_bulb": "Verwitterte Kupferleuchte",
  "block.minecraft.weathered_copper_chain": "Verwitterte Kupferkette",
  "block.minecraft.weathered_copper_chest": "Verwitterte Kupfertruhe",
  "block.minecraft.weathered_copper_door": "Verwitterte Kupfertür",
  "block.minecraft.weathered_copper_golem_statue": "Verwitterte Kupfergolemstatue",
  "block.minecraft.weathered_copper_grate": "Verwitterter Kupferrost",
  "block.minecraft.weathered_copper_lantern": "Verwitterte Kupferlaterne",
  "block.minecraft.weathered_copper_trapdoor": "Verwitterte Kupferfalltür",
  "block.minecraft.weathered_cut_copper": "Weddere schnigge Kofferblock",
  "block.minecraft.weathered_cut_copper_slab": "Weddere schnigge Kofferstof",
  "block.minecraft.weathered_cut_copper_stairs": "Weddere schnigge Koffertrapp",
  "block.minecraft.weathered_lightning_rod": "Verwitterter Blitzableiter",
  "block.minecraft.weeping_vines": "Troorranke",
  "block.minecraft.weeping_vines_plant": "Troorrankeplant",
  "block.minecraft.wet_sponge": "Nasse Schwamm",
  "block.minecraft.wheat": "Weizzeplant",
  "block.minecraft.white_banner": "Wieße Fahn",
  "block.minecraft.white_bed": "Wieß Bett",
  "block.minecraft.white_candle": "Wieße Käz",
  "block.minecraft.white_candle_cake": "Kooche met wieße Kääz",
  "block.minecraft.white_carpet": "Wieße Teppich",
  "block.minecraft.white_concrete": "Wieße Betong",
  "block.minecraft.white_concrete_powder": "Wieße Drüchbetong",
  "block.minecraft.white_glazed_terracotta": "Wieß jlaseet Steinjot",
  "block.minecraft.white_shulker_box": "Wieße Shulker-Keß",
  "block.minecraft.white_stained_glass": "Wieß jefärv Jlas",
  "block.minecraft.white_stained_glass_pane": "Wieß jefärv Jlasschiev",
  "block.minecraft.white_terracotta": "Wieß Steinjot",
  "block.minecraft.white_tulip": "Wieße Tulp",
  "block.minecraft.white_wool": "Wieße Woll",
  "block.minecraft.wildflowers": "Wildblumen",
  "block.minecraft.wither_rose": "Witherrus",
  "block.minecraft.wither_skeleton_skull": "Witherjereppdudekopp",
  "block.minecraft.wither_skeleton_wall_skull": "Witherjereppwanddudekopp",
  "block.minecraft.yellow_banner": "Jäl Fahn",
  "block.minecraft.yellow_bed": "Jäl Bett",
  "block.minecraft.yellow_candle": "Jäl Käz",
  "block.minecraft.yellow_candle_cake": "Kooche met jäle Kääz",
  "block.minecraft.yellow_carpet": "Jäle Teppich",
  "block.minecraft.yellow_concrete": "Jäle Betong",
  "block.minecraft.yellow_concrete_powder": "Jäle Drüchbetong",
  "block.minecraft.yellow_glazed_terracotta": "Jäl jlaseet Steinjot",
  "block.minecraft.yellow_shulker_box": "Jäl Shulker-Keß",
  "block.minecraft.yellow_stained_glass": "Jäl jefärv Jlas",
  "block.minecraft.yellow_stained_glass_pane": "Jäl jefärv Jlasschiev",
  "block.minecraft.yellow_terracotta": "Jäl Steinjot",
  "block.minecraft.yellow_wool": "Jäle Woll",
  "block.minecraft.zombie_head": "Zombikopp",
  "block.minecraft.zombie_wall_head": "Zombiwandkopp",
  "item.minecraft.acacia_boat": "Akazijeholzböötche",
  "item.minecraft.acacia_chest_boat": "Akazienholztruhenboot",
  "item.minecraft.allay_spawn_egg": "Hilfsgeister-Spawn-Ei",
  "item.minecraft.amethyst_shard": "Ametüstscherv",
  "item.minecraft.angler_pottery_shard": "Angler-Töpferscherbe",
  "item.minecraft.angler_pottery_sherd": "Angler-Töpferscherbe",
  "item.minecraft.apple": "Appel",
  "item.minecraft.archer_pottery_shard": "Schützen-Töpferscherbe",
  "item.minecraft.archer_pottery_sherd": "Schützen-Töpferscherbe",
  "item.minecraft.armadillo_scute": "Gürteltier-Hornschild",
  "item.minecraft.armadillo_spawn_egg": "Gürteltier-Spawn-Ei",
  "item.minecraft.armor_stand": "Röstungsständer",
  "item.minecraft.arms_up_pottery_shard": "Gebärden-Töpferscherbe",
  "item.minecraft.arms_up_pottery_sherd": "Gebärden-Töpferscherbe",
  "item.minecraft.arrow": "Piel",
  "item.minecraft.axolotl_bucket": "Axolotlemmer",
  "item.minecraft.axolotl_spawn_egg": "Axolotl-Spawn-Ei",
  "item.minecraft.baked_potato": "Quallmann",
  "item.minecraft.bamboo_chest_raft": "Bambus-Truhenfloß",
  "item.minecraft.bamboo_raft": "Bambusfloß",
  "item.minecraft.bat_spawn_egg": "Fleddermuus-Spawn-Ei",
  "item.minecraft.bee_spawn_egg": "Beie-Spawn-Ei",
  "item.minecraft.beef": "Rüh Rindfleisch",
  "item.minecraft.beetroot": "Rude Bete",
  "item.minecraft.beetroot_seeds": "Rude-Bete-Some",
  "item.minecraft.beetroot_soup": "Rude-Bete-Zupp",
  "item.minecraft.birch_boat": "Birkeholzböötche",
  "item.minecraft.birch_chest_boat": "Birkenholztruhenboot",
  "item.minecraft.black_bundle": "Schwarzes Bündel",
  "item.minecraft.black_dye": "Schwatze Färv",
  "item.minecraft.black_harness": "Schwarzes Geschirr",
  "item.minecraft.blade_pottery_shard": "Klingen-Töpferscherbe",
  "item.minecraft.blade_pottery_sherd": "Klingen-Töpferscherbe",
  "item.minecraft.blaze_powder": "Förstangstöbb",
  "item.minecraft.blaze_rod": "Förstang",
  "item.minecraft.blaze_spawn_egg": "Förmann-Spawn-Ei",
  "item.minecraft.blue_bundle": "Blaues Bündel",
  "item.minecraft.blue_dye": "Blaue Färv",
  "item.minecraft.blue_egg": "Blaues Ei",
  "item.minecraft.blue_harness": "Blaues Geschirr",
  "item.minecraft.bogged_spawn_egg": "Sumpfskelett-Spawn-Ei",
  "item.minecraft.bolt_armor_trim_smithing_template": "Schmiedevorlage",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Bolzen-Rüstungsbesatz",
  "item.minecraft.bone": "Knoche",
  "item.minecraft.bone_meal": "Knochemähl",
  "item.minecraft.book": "Boch",
  "item.minecraft.bordure_indented_banner_pattern": "Spickelbord-Bannervorlage",
  "item.minecraft.bow": "Flitschborre",
  "item.minecraft.bowl": "Kump",
  "item.minecraft.bread": "Brut",
  "item.minecraft.breeze_rod": "Böenrute",
  "item.minecraft.breeze_spawn_egg": "Böen-Spawn-Ei",
  "item.minecraft.brewer_pottery_shard": "Brauer-Töpferscherbe",
  "item.minecraft.brewer_pottery_sherd": "Brauer-Töpferscherbe",
  "item.minecraft.brewing_stand": "Braues",
  "item.minecraft.brick": "Ziejel",
  "item.minecraft.brown_bundle": "Braunes Bündel",
  "item.minecraft.brown_dye": "Brunge Färv",
  "item.minecraft.brown_egg": "Braunes Ei",
  "item.minecraft.brown_harness": "Braunes Geschirr",
  "item.minecraft.brush": "Pinsel",
  "item.minecraft.bucket": "Emmer",
  "item.minecraft.bundle": "Bündel",
  "item.minecraft.bundle.empty": "Leer",
  "item.minecraft.bundle.empty.description": "Nimmt einen gemischten Stapel Gegenstände auf",
  "item.minecraft.bundle.full": "Voll",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Flammen-Töpferscherbe",
  "item.minecraft.burn_pottery_sherd": "Flammen-Töpferscherbe",
  "item.minecraft.camel_husk_spawn_egg": "Zombiedromedar-Spawn-Ei",
  "item.minecraft.camel_spawn_egg": "Dromedar-Spawn-Ei",
  "item.minecraft.carrot": "Mohr",
  "item.minecraft.carrot_on_a_stick": "Mohr am Stock",
  "item.minecraft.cat_spawn_egg": "Katze-Spawn-Ei",
  "item.minecraft.cauldron": "Bütt",
  "item.minecraft.cave_spider_spawn_egg": "Höhlespenne-Spawn-Ei",
  "item.minecraft.chainmail_boots": "Kettestivvel",
  "item.minecraft.chainmail_chestplate": "Kettehemp",
  "item.minecraft.chainmail_helmet": "Kettemötz",
  "item.minecraft.chainmail_leggings": "Kettebotz",
  "item.minecraft.charcoal": "Holzkoll",
  "item.minecraft.cherry_boat": "Kirschholzboot",
  "item.minecraft.cherry_chest_boat": "Kirschholztruhenboot",
  "item.minecraft.chest_minecart": "Fraachkar",
  "item.minecraft.chicken": "Rüh Hoon",
  "item.minecraft.chicken_spawn_egg": "Höhner-Spawn-Ei",
  "item.minecraft.chorus_fruit": "Chorusfruch",
  "item.minecraft.clay_ball": "Kleiklumpe",
  "item.minecraft.clock": "Ohr",
  "item.minecraft.coal": "Koll",
  "item.minecraft.coast_armor_trim_smithing_template": "Schmiedevorlage",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Küsten-Rüstungsbesatz",
  "item.minecraft.cocoa_beans": "Kakaubunne",
  "item.minecraft.cod": "Rühe Kabbeljau",
  "item.minecraft.cod_bucket": "Kabbeljauemmer",
  "item.minecraft.cod_spawn_egg": "Kabbeljau-Spawn-Ei",
  "item.minecraft.command_block_minecart": "Befellsblockkar",
  "item.minecraft.compass": "Kompaß",
  "item.minecraft.cooked_beef": "Böfstöck",
  "item.minecraft.cooked_chicken": "Jebrode Hoon",
  "item.minecraft.cooked_cod": "Jebrode Kabbeljau",
  "item.minecraft.cooked_mutton": "Jebrode Schofsfleisch",
  "item.minecraft.cooked_porkchop": "Hämmche",
  "item.minecraft.cooked_rabbit": "Jebrode Kning",
  "item.minecraft.cooked_salmon": "Jebrode Lachs",
  "item.minecraft.cookie": "Plätzje",
  "item.minecraft.copper_axe": "Kupferaxt",
  "item.minecraft.copper_boots": "Kupferstiefel",
  "item.minecraft.copper_chestplate": "Kupferharnisch",
  "item.minecraft.copper_golem_spawn_egg": "Kupfergolem-Spawn-Ei",
  "item.minecraft.copper_helmet": "Kupferhelm",
  "item.minecraft.copper_hoe": "Kupferhacke",
  "item.minecraft.copper_horse_armor": "Kupferner Rossharnisch",
  "item.minecraft.copper_ingot": "Kofferbrikett",
  "item.minecraft.copper_leggings": "Kupferbeinschutz",
  "item.minecraft.copper_nautilus_armor": "Kupferner Nautiluspanzer",
  "item.minecraft.copper_nugget": "Kupferklumpen",
  "item.minecraft.copper_pickaxe": "Kupferspitzhacke",
  "item.minecraft.copper_shovel": "Kupferschaufel",
  "item.minecraft.copper_spear": "Kupferspeer",
  "item.minecraft.copper_sword": "Kupferschwert",
  "item.minecraft.cow_spawn_egg": "Koh-Spawn-Ei",
  "item.minecraft.creaking_spawn_egg": "Knarz-Spawn-Ei",
  "item.minecraft.creeper_banner_pattern": "Fahnevörlach",
  "item.minecraft.creeper_banner_pattern.desc": "Creeper",
  "item.minecraft.creeper_banner_pattern.new": "Creeper-Bannervorlage",
  "item.minecraft.creeper_spawn_egg": "Creeper-Spawn-Ei",
  "item.minecraft.crossbow": "Ärmbruß",
  "item.minecraft.crossbow.projectile": "Jeschoss:",
  "item.minecraft.crossbow.projectile.multiple": "Geschoss: %s× %s",
  "item.minecraft.crossbow.projectile.single": "Geschoss: %s",
  "item.minecraft.cyan_bundle": "Türkises Bündel",
  "item.minecraft.cyan_dye": "Blaujrön Färv",
  "item.minecraft.cyan_harness": "Türkises Geschirr",
  "item.minecraft.danger_pottery_shard": "Gefahren-Töpferscherbe",
  "item.minecraft.danger_pottery_sherd": "Gefahren-Töpferscherbe",
  "item.minecraft.dark_oak_boat": "Schwatzeescheholzböötche",
  "item.minecraft.dark_oak_chest_boat": "Schwarzeichenholztruhenboot",
  "item.minecraft.debug_stick": "Debug-Stock",
  "item.minecraft.debug_stick.empty": "%s hät kein Blöckzoständ",
  "item.minecraft.debug_stick.select": "„%s“ Usjesök (%s)",
  "item.minecraft.debug_stick.update": "„%s“ is jetz %s",
  "item.minecraft.diamond": "Dijamant",
  "item.minecraft.diamond_axe": "Dijamantax",
  "item.minecraft.diamond_boots": "Dijamantstivvel",
  "item.minecraft.diamond_chestplate": "Dijamantharnisch",
  "item.minecraft.diamond_helmet": "Dijamanthellm",
  "item.minecraft.diamond_hoe": "Dijamanthau",
  "item.minecraft.diamond_horse_armor": "Dijamantene Pädsharnisch",
  "item.minecraft.diamond_leggings": "Dijamantbotz",
  "item.minecraft.diamond_nautilus_armor": "Diamantener Nautiluspanzer",
  "item.minecraft.diamond_pickaxe": "Dijamantpielhau",
  "item.minecraft.diamond_shovel": "Dijamantschöpp",
  "item.minecraft.diamond_spear": "Diamantspeer",
  "item.minecraft.diamond_sword": "Dijamantschwäät",
  "item.minecraft.disc_fragment_5": "Plattenbruchstück",
  "item.minecraft.disc_fragment_5.desc": "Schallplatte - 5",
  "item.minecraft.dolphin_spawn_egg": "Delfin-Spawn-Ei",
  "item.minecraft.donkey_spawn_egg": "Äsel-Spawn-Ei",
  "item.minecraft.dragon_breath": "Dracheodem",
  "item.minecraft.dried_kelp": "Drüjje Sietang",
  "item.minecraft.drowned_spawn_egg": "Versoffener-Spawn-Ei",
  "item.minecraft.dune_armor_trim_smithing_template": "Schmiedevorlage",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Dünen-Rüstungsbesatz",
  "item.minecraft.echo_shard": "Echoscherbe",
  "item.minecraft.egg": "Ei",
  "item.minecraft.elder_guardian_spawn_egg": "Jroße-Waach-Spawn-Ei",
  "item.minecraft.elytra": "Flöjel",
  "item.minecraft.emerald": "Smarak",
  "item.minecraft.enchanted_book": "Verzaubert Boch",
  "item.minecraft.enchanted_golden_apple": "Verzauberte joldene Appel",
  "item.minecraft.end_crystal": "Endkrestall",
  "item.minecraft.ender_dragon_spawn_egg": "Enderdrachen-Spawn-Ei",
  "item.minecraft.ender_eye": "Enderauch",
  "item.minecraft.ender_pearl": "Enderpäl",
  "item.minecraft.enderman_spawn_egg": "Enderman-Spawn-Ei",
  "item.minecraft.endermite_spawn_egg": "Endermite-Spawn-Ei",
  "item.minecraft.evoker_spawn_egg": "Majier-Spawn-Ei",
  "item.minecraft.experience_bottle": "Erfahrongsfläsch",
  "item.minecraft.explorer_pottery_shard": "Entdecker-Töpferscherbe",
  "item.minecraft.explorer_pottery_sherd": "Entdecker-Töpferscherbe",
  "item.minecraft.eye_armor_trim_smithing_template": "Schmiedevorlage",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Augen-Rüstungsbesatz",
  "item.minecraft.feather": "Fädder",
  "item.minecraft.fermented_spider_eye": "Jejorre Spenneauch",
  "item.minecraft.field_masoned_banner_pattern": "Mauerung-Bannervorlage",
  "item.minecraft.filled_map": "Kaat",
  "item.minecraft.fire_charge": "Förkuchel",
  "item.minecraft.firework_rocket": "Förwerksraket",
  "item.minecraft.firework_rocket.flight": "Flochzick:",
  "item.minecraft.firework_rocket.multiple_stars": "%s× %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Förwerksstän",
  "item.minecraft.firework_star.black": "Schwatz",
  "item.minecraft.firework_star.blue": "Blau",
  "item.minecraft.firework_star.brown": "Brung",
  "item.minecraft.firework_star.custom_color": "Benutzerdefiniert",
  "item.minecraft.firework_star.cyan": "Blaujrön",
  "item.minecraft.firework_star.fade_to": "Üvverjang zo",
  "item.minecraft.firework_star.flicker": "Funkele",
  "item.minecraft.firework_star.gray": "Jrau",
  "item.minecraft.firework_star.green": "Jrön",
  "item.minecraft.firework_star.light_blue": "Hellblau",
  "item.minecraft.firework_star.light_gray": "Helljrau",
  "item.minecraft.firework_star.lime": "Helljrön",
  "item.minecraft.firework_star.magenta": "Majenta",
  "item.minecraft.firework_star.orange": "Orangsch",
  "item.minecraft.firework_star.pink": "Rusa",
  "item.minecraft.firework_star.purple": "Vijelett",
  "item.minecraft.firework_star.red": "Rut",
  "item.minecraft.firework_star.shape": "Nit jekannte Form",
  "item.minecraft.firework_star.shape.burst": "Zerplatze",
  "item.minecraft.firework_star.shape.creeper": "Creeperjeformp",
  "item.minecraft.firework_star.shape.large_ball": "Jroße Ball",
  "item.minecraft.firework_star.shape.small_ball": "Bällche",
  "item.minecraft.firework_star.shape.star": "Stänjeformp",
  "item.minecraft.firework_star.trail": "Stätz",
  "item.minecraft.firework_star.white": "Wieß",
  "item.minecraft.firework_star.yellow": "Jäl",
  "item.minecraft.fishing_rod": "Feschjät",
  "item.minecraft.flint": "Förstein",
  "item.minecraft.flint_and_steel": "Förzüch",
  "item.minecraft.flow_armor_trim_smithing_template": "Schmiedevorlage",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Fluss-Rüstungsbesatz",
  "item.minecraft.flow_banner_pattern": "Bannervorlage",
  "item.minecraft.flow_banner_pattern.desc": "Fluss",
  "item.minecraft.flow_banner_pattern.new": "Fluss-Bannervorlage",
  "item.minecraft.flow_pottery_sherd": "Fluss-Töpferscherbe",
  "item.minecraft.flower_banner_pattern": "Fahnevörlach",
  "item.minecraft.flower_banner_pattern.desc": "Blom",
  "item.minecraft.flower_banner_pattern.new": "Blumen-Bannervorlage",
  "item.minecraft.flower_pot": "Blumentopf",
  "item.minecraft.fox_spawn_egg": "Fuss-Spawn-Ei",
  "item.minecraft.friend_pottery_shard": "Freundes-Töpferscherbe",
  "item.minecraft.friend_pottery_sherd": "Freundes-Töpferscherbe",
  "item.minecraft.frog_spawn_egg": "Frosch-Spawn-Ei",
  "item.minecraft.furnace_minecart": "Lokemotiv",
  "item.minecraft.ghast_spawn_egg": "Ghast-Spawn-Ei",
  "item.minecraft.ghast_tear": "Ghast-Tron",
  "item.minecraft.glass_bottle": "Jlasfläsch",
  "item.minecraft.glistering_melon_slice": "Jlitzernde Meloneschiev",
  "item.minecraft.globe_banner_pattern": "Fahnevörlach",
  "item.minecraft.globe_banner_pattern.desc": "Jlobus",
  "item.minecraft.globe_banner_pattern.new": "Globus-Bannervorlage",
  "item.minecraft.glow_berries": "Leuchtbeeren",
  "item.minecraft.glow_ink_sac": "Leuchtinkbüggel",
  "item.minecraft.glow_item_frame": "Leuchtrohme",
  "item.minecraft.glow_squid_spawn_egg": "Leuchtinkfesch-Spawn-Ei",
  "item.minecraft.glowstone_dust": "Lööchstein-Stöbb",
  "item.minecraft.goat_horn": "Bockshorn",
  "item.minecraft.goat_spawn_egg": "Jeiße-Spawn-Ei",
  "item.minecraft.gold_ingot": "Joldbrikett",
  "item.minecraft.gold_nugget": "Joldklumpe",
  "item.minecraft.golden_apple": "Joldene Appel",
  "item.minecraft.golden_axe": "Joldax",
  "item.minecraft.golden_boots": "Joldkamasche",
  "item.minecraft.golden_carrot": "Jolden Mohr",
  "item.minecraft.golden_chestplate": "Joldharnisch",
  "item.minecraft.golden_helmet": "Joldhellm",
  "item.minecraft.golden_hoe": "Joldhau",
  "item.minecraft.golden_horse_armor": "Joldene Pädsharnisch",
  "item.minecraft.golden_leggings": "Joldbotz",
  "item.minecraft.golden_nautilus_armor": "Goldener Nautiluspanzer",
  "item.minecraft.golden_pickaxe": "Joldpielhau",
  "item.minecraft.golden_shovel": "Joldschöpp",
  "item.minecraft.golden_spear": "Goldspeer",
  "item.minecraft.golden_sword": "Joldschwäät",
  "item.minecraft.gray_bundle": "Graues Bündel",
  "item.minecraft.gray_dye": "Jrau Färv",
  "item.minecraft.gray_harness": "Graues Geschirr",
  "item.minecraft.green_bundle": "Grünes Bündel",
  "item.minecraft.green_dye": "Jrön Färv",
  "item.minecraft.green_harness": "Grünes Geschirr",
  "item.minecraft.guardian_spawn_egg": "Waach-Spawn-Ei",
  "item.minecraft.gunpowder": "Schwatzpolver",
  "item.minecraft.guster_banner_pattern": "Bannervorlage",
  "item.minecraft.guster_banner_pattern.desc": "Windstoßer",
  "item.minecraft.guster_banner_pattern.new": "Windstoßer-Bannervorlage",
  "item.minecraft.guster_pottery_sherd": "Windstoßer-Töpferscherbe",
  "item.minecraft.happy_ghast_spawn_egg": "Glücklicher-Ghast-Spawn-Ei",
  "item.minecraft.harness": "Geschirr",
  "item.minecraft.heart_of_the_sea": "Meerhätz",
  "item.minecraft.heart_pottery_shard": "Herz-Töpferscherbe",
  "item.minecraft.heart_pottery_sherd": "Herz-Töpferscherbe",
  "item.minecraft.heartbreak_pottery_shard": "Herzschmerz-Töpferscherbe",
  "item.minecraft.heartbreak_pottery_sherd": "Herzschmerz-Töpferscherbe",
  "item.minecraft.hoglin_spawn_egg": "Hoglin-Spawn-Ei",
  "item.minecraft.honey_bottle": "Honnichfläsch",
  "item.minecraft.honeycomb": "Honnichwov",
  "item.minecraft.hopper_minecart": "Treechtekar",
  "item.minecraft.horse_spawn_egg": "Päd-Spawn-Ei",
  "item.minecraft.host_armor_trim_smithing_template": "Schmiedevorlage",
  "item.minecraft.host_armor_trim_smithing_template.new": "Gastwirts-Rüstungsbesatz",
  "item.minecraft.howl_pottery_shard": "Geheul-Töpferscherbe",
  "item.minecraft.howl_pottery_sherd": "Geheul-Töpferscherbe",
  "item.minecraft.husk_spawn_egg": "Wöstezombi-Spawn-Ei",
  "item.minecraft.ink_sac": "Inkbüggel",
  "item.minecraft.iron_axe": "Ieseax",
  "item.minecraft.iron_boots": "Iesestivvel",
  "item.minecraft.iron_chestplate": "Ieseharnisch",
  "item.minecraft.iron_golem_spawn_egg": "Eisengolem-Spawn-Ei",
  "item.minecraft.iron_helmet": "Iesehellm",
  "item.minecraft.iron_hoe": "Iesehau",
  "item.minecraft.iron_horse_armor": "Ieser Pädsharnisch",
  "item.minecraft.iron_ingot": "Iesebrikett",
  "item.minecraft.iron_leggings": "Iesebotz",
  "item.minecraft.iron_nautilus_armor": "Eiserner Nautiluspanzer",
  "item.minecraft.iron_nugget": "Ieseklumpe",
  "item.minecraft.iron_pickaxe": "Iesepielhau",
  "item.minecraft.iron_shovel": "Ieseschöpp",
  "item.minecraft.iron_spear": "Eisenspeer",
  "item.minecraft.iron_sword": "Ieseschwäät",
  "item.minecraft.item_frame": "Rohme",
  "item.minecraft.jungle_boat": "Tropeholzböötche",
  "item.minecraft.jungle_chest_boat": "Tropenholztruhenboot",
  "item.minecraft.knowledge_book": "Boch vum Wesse",
  "item.minecraft.lapis_lazuli": "Lapislazoli",
  "item.minecraft.lava_bucket": "Lavaemmer",
  "item.minecraft.lead": "Ling",
  "item.minecraft.leather": "Ledder",
  "item.minecraft.leather_boots": "Ledderstivvel",
  "item.minecraft.leather_chestplate": "Ledderjopp",
  "item.minecraft.leather_helmet": "Leddermötz",
  "item.minecraft.leather_horse_armor": "Ledderne Pädsharnisch",
  "item.minecraft.leather_leggings": "Ledderbotz",
  "item.minecraft.light_blue_bundle": "Hellblaues Bündel",
  "item.minecraft.light_blue_dye": "Hellblau Färv",
  "item.minecraft.light_blue_harness": "Hellblaues Geschirr",
  "item.minecraft.light_gray_bundle": "Hellgraues Bündel",
  "item.minecraft.light_gray_dye": "Helljrau Färv",
  "item.minecraft.light_gray_harness": "Hellgraues Geschirr",
  "item.minecraft.lime_bundle": "Hellgrünes Bündel",
  "item.minecraft.lime_dye": "Helljrön Färv",
  "item.minecraft.lime_harness": "Hellgrünes Geschirr",
  "item.minecraft.lingering_potion": "Blievende Drank",
  "item.minecraft.lingering_potion.effect.awkward": "Blievende Komische Drank",
  "item.minecraft.lingering_potion.effect.empty": "Blievende nit braubare Drank",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Blievender Förschotzdrank",
  "item.minecraft.lingering_potion.effect.harming": "Blievende Kapottdrank",
  "item.minecraft.lingering_potion.effect.healing": "Blievende Heilungsdrank",
  "item.minecraft.lingering_potion.effect.infested": "Verweiltrank des Befalls",
  "item.minecraft.lingering_potion.effect.invisibility": "Blievender Onsechbarkeetsdrank",
  "item.minecraft.lingering_potion.effect.leaping": "Blievender Höppkraffdrank",
  "item.minecraft.lingering_potion.effect.levitation": "Blievende Schwevvdrank",
  "item.minecraft.lingering_potion.effect.luck": "Blievende Jlöcksdrank",
  "item.minecraft.lingering_potion.effect.mundane": "Blievende jewöhnliche Drank",
  "item.minecraft.lingering_potion.effect.night_vision": "Blievender Nachseechsdrank",
  "item.minecraft.lingering_potion.effect.oozing": "Verweiltrank des Schleimens",
  "item.minecraft.lingering_potion.effect.poison": "Blievende Jeffdrank",
  "item.minecraft.lingering_potion.effect.regeneration": "Blievender Rejenerazijonsdrank",
  "item.minecraft.lingering_potion.effect.slow_falling": "Blievende Langsamfalldrank",
  "item.minecraft.lingering_potion.effect.slowness": "Blievender Langsamheetsdrank",
  "item.minecraft.lingering_potion.effect.strength": "Blievender Stärkedrank",
  "item.minecraft.lingering_potion.effect.swiftness": "Blievender Jeschwindechkeetsdrank",
  "item.minecraft.lingering_potion.effect.thick": "Blievende deckflössije Drank",
  "item.minecraft.lingering_potion.effect.turtle_master": "Blievende Scheldkraatedrank",
  "item.minecraft.lingering_potion.effect.water": "Blievende Wasserfläsch",
  "item.minecraft.lingering_potion.effect.water_breathing": "Blievender Ungerwasserodemsdrank",
  "item.minecraft.lingering_potion.effect.weakness": "Blievender Schwächheetsdrank",
  "item.minecraft.lingering_potion.effect.weaving": "Verweiltrank des Webens",
  "item.minecraft.lingering_potion.effect.wind_charged": "Verweiltrank der Windladung",
  "item.minecraft.llama_spawn_egg": "Lama-Spawn-Ei",
  "item.minecraft.lodestone_compass": "Leitstein-Kompaß",
  "item.minecraft.mace": "Streitkolben",
  "item.minecraft.magenta_bundle": "Magenta Bündel",
  "item.minecraft.magenta_dye": "Majenta Färv",
  "item.minecraft.magenta_harness": "Magenta Geschirr",
  "item.minecraft.magma_cream": "Machmakräm",
  "item.minecraft.magma_cube_spawn_egg": "Machmaklötsch-Spawn-Ei",
  "item.minecraft.mangrove_boat": "Mangrovenholzboot",
  "item.minecraft.mangrove_chest_boat": "Mangrovenholztruhenboot",
  "item.minecraft.map": "Leddisch Kaat",
  "item.minecraft.melon_seeds": "Melonekäne",
  "item.minecraft.melon_slice": "Meloneschiev",
  "item.minecraft.milk_bucket": "Melleschemmer",
  "item.minecraft.minecart": "Kar",
  "item.minecraft.miner_pottery_shard": "Bergarbeiter-Töpferscherbe",
  "item.minecraft.miner_pottery_sherd": "Bergarbeiter-Töpferscherbe",
  "item.minecraft.mojang_banner_pattern": "Fahnevörlach",
  "item.minecraft.mojang_banner_pattern.desc": "Mojang-Wappe",
  "item.minecraft.mojang_banner_pattern.new": "Mojang-Logo-Bannervorlage",
  "item.minecraft.mooshroom_spawn_egg": "Mooshroom-Spawn-Ei",
  "item.minecraft.mourner_pottery_shard": "Wimmerer-Töpferscherbe",
  "item.minecraft.mourner_pottery_sherd": "Wimmerer-Töpferscherbe",
  "item.minecraft.mule_spawn_egg": "Muuläsel-Spawn-Ei",
  "item.minecraft.mushroom_stew": "Pelzzupp",
  "item.minecraft.music_disc_11": "Musikplaat",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Musikplaat",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Musikplaat",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Musikplaat",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Musikplaat",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Musikplaat",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Schallplatte",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Schallplatte",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Spieluhr)",
  "item.minecraft.music_disc_far": "Musikplaat",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Schallplatte",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Musikplaat",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Musikplaat",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Musikplaat",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Musikplaat",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Schallplatte",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Schallplatte",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Musikplaat",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Musikplaat",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Schallplatte",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Musikplaat",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Musikplaat",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Rüh Schofsfleisch",
  "item.minecraft.name_tag": "Namescheld",
  "item.minecraft.nautilus_shell": "Nautiluschal",
  "item.minecraft.nautilus_spawn_egg": "Nautilus-Spawn-Ei",
  "item.minecraft.nether_brick": "Netherziejel",
  "item.minecraft.nether_star": "Netherstän",
  "item.minecraft.nether_wart": "Netherwarze",
  "item.minecraft.netherite_axe": "Netheritax",
  "item.minecraft.netherite_boots": "Netheritstivvel",
  "item.minecraft.netherite_chestplate": "Netheritharnisch",
  "item.minecraft.netherite_helmet": "Netherithellm",
  "item.minecraft.netherite_hoe": "Netherithau",
  "item.minecraft.netherite_horse_armor": "Netheritener Rossharnisch",
  "item.minecraft.netherite_ingot": "Netheritbrikett",
  "item.minecraft.netherite_leggings": "Netheritbotz",
  "item.minecraft.netherite_nautilus_armor": "Netheritener Nautiluspanzer",
  "item.minecraft.netherite_pickaxe": "Netheritpielhau",
  "item.minecraft.netherite_scrap": "Netheritplaate",
  "item.minecraft.netherite_shovel": "Netheritschöpp",
  "item.minecraft.netherite_spear": "Netheritspeer",
  "item.minecraft.netherite_sword": "Netheritschwäät",
  "item.minecraft.netherite_upgrade_smithing_template": "Schmiedevorlage",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Netheritaufwertung",
  "item.minecraft.oak_boat": "Eescheholzböötche",
  "item.minecraft.oak_chest_boat": "Eichenholztruhenboot",
  "item.minecraft.ocelot_spawn_egg": "Jeflekte-Katz-Spawn-Ei",
  "item.minecraft.ominous_bottle": "Unheilvolle Flasche",
  "item.minecraft.ominous_trial_key": "Unheilvoller Prüfungsschlüssel",
  "item.minecraft.orange_bundle": "Oranges Bündel",
  "item.minecraft.orange_dye": "Orangsch Färv",
  "item.minecraft.orange_harness": "Oranges Geschirr",
  "item.minecraft.painting": "Jemälde",
  "item.minecraft.pale_oak_boat": "Blasseichenholzboot",
  "item.minecraft.pale_oak_chest_boat": "Blasseichenholztruhenboot",
  "item.minecraft.panda_spawn_egg": "Panda-Spawn-Ei",
  "item.minecraft.paper": "Papeer",
  "item.minecraft.parched_spawn_egg": "Vertrockneten-Spawn-Ei",
  "item.minecraft.parrot_spawn_egg": "Papejeie-Spawn-Ei",
  "item.minecraft.phantom_membrane": "Fantomhuck",
  "item.minecraft.phantom_spawn_egg": "Fantom-Spawn-Ei",
  "item.minecraft.pig_spawn_egg": "Sau-Spawn-Ei",
  "item.minecraft.piglin_banner_pattern": "Fahnevörlach",
  "item.minecraft.piglin_banner_pattern.desc": "Schnüß",
  "item.minecraft.piglin_banner_pattern.new": "Schnauzen-Bannervorlage",
  "item.minecraft.piglin_brute_spawn_egg": "Piglin-Barbaren-Spawn-Ei",
  "item.minecraft.piglin_spawn_egg": "Piglin-Spawn-Ei",
  "item.minecraft.pillager_spawn_egg": "Plüngere-Spawn-Ei",
  "item.minecraft.pink_bundle": "Rosa Bündel",
  "item.minecraft.pink_dye": "Rusa Färv",
  "item.minecraft.pink_harness": "Rosa Geschirr",
  "item.minecraft.pitcher_plant": "Kannenpflanze",
  "item.minecraft.pitcher_pod": "Kannenpflanzenkapsel",
  "item.minecraft.plenty_pottery_shard": "Reichtums-Töpferscherbe",
  "item.minecraft.plenty_pottery_sherd": "Reichtums-Töpferscherbe",
  "item.minecraft.poisonous_potato": "Jefftije Ädappel",
  "item.minecraft.polar_bear_spawn_egg": "Iesbär-Spawn-Ei",
  "item.minecraft.popped_chorus_fruit": "Jeplatzte Chorusfruch",
  "item.minecraft.porkchop": "Rüh Schweinefleisch",
  "item.minecraft.potato": "Ädappel",
  "item.minecraft.potion": "Drank",
  "item.minecraft.potion.effect.awkward": "Komische Drank",
  "item.minecraft.potion.effect.empty": "Nit braubare Drank",
  "item.minecraft.potion.effect.fire_resistance": "Förschotzdrank",
  "item.minecraft.potion.effect.harming": "Kapottdrank",
  "item.minecraft.potion.effect.healing": "Heilungsdrank",
  "item.minecraft.potion.effect.infested": "Trank des Befalls",
  "item.minecraft.potion.effect.invisibility": "Onsechbarkeetsdrank",
  "item.minecraft.potion.effect.leaping": "Höppkraffdrank",
  "item.minecraft.potion.effect.levitation": "Schwevvdrank",
  "item.minecraft.potion.effect.luck": "Jlöcksdrank",
  "item.minecraft.potion.effect.mundane": "Jewöhnliche Drank",
  "item.minecraft.potion.effect.night_vision": "Nachseechsdrank",
  "item.minecraft.potion.effect.oozing": "Trank des Schleimens",
  "item.minecraft.potion.effect.poison": "Jeffdrank",
  "item.minecraft.potion.effect.regeneration": "Rejenerazijonsdrank",
  "item.minecraft.potion.effect.slow_falling": "Langsamfalldrank",
  "item.minecraft.potion.effect.slowness": "Langsamheetsdrank",
  "item.minecraft.potion.effect.strength": "Stärkedrank",
  "item.minecraft.potion.effect.swiftness": "Jeschwindechkeetsdrank",
  "item.minecraft.potion.effect.thick": "Deckflössije Drank",
  "item.minecraft.potion.effect.turtle_master": "Scheldkraatedrank",
  "item.minecraft.potion.effect.water": "Wasserfläsch",
  "item.minecraft.potion.effect.water_breathing": "Ungerwasserodemsdrank",
  "item.minecraft.potion.effect.weakness": "Schwächheetsdrank",
  "item.minecraft.potion.effect.weaving": "Trank des Webens",
  "item.minecraft.potion.effect.wind_charged": "Trank der Windladung",
  "item.minecraft.pottery_shard_archer": "Schützen-Töpferscherbe",
  "item.minecraft.pottery_shard_arms_up": "Gebärden-Töpferscherbe",
  "item.minecraft.pottery_shard_prize": "Juwelen-Töpferscherbe",
  "item.minecraft.pottery_shard_skull": "Totenkopf-Töpferscherbe",
  "item.minecraft.powder_snow_bucket": "Polverschnieemmer",
  "item.minecraft.prismarine_crystals": "Prismarinkrestall",
  "item.minecraft.prismarine_shard": "Prismarinscherv",
  "item.minecraft.prize_pottery_shard": "Juwelen-Töpferscherbe",
  "item.minecraft.prize_pottery_sherd": "Juwelen-Töpferscherbe",
  "item.minecraft.pufferfish": "Kujelfesch",
  "item.minecraft.pufferfish_bucket": "Kujelfeschemmer",
  "item.minecraft.pufferfish_spawn_egg": "Kujelfesch-Spawn-Ei",
  "item.minecraft.pumpkin_pie": "Kürbiskooche",
  "item.minecraft.pumpkin_seeds": "Kürbiskäne",
  "item.minecraft.purple_bundle": "Violettes Bündel",
  "item.minecraft.purple_dye": "Vijelett Färv",
  "item.minecraft.purple_harness": "Violettes Geschirr",
  "item.minecraft.quartz": "Netherkwarz",
  "item.minecraft.rabbit": "Rüh Kning",
  "item.minecraft.rabbit_foot": "Kningsklau",
  "item.minecraft.rabbit_hide": "Kningspelz",
  "item.minecraft.rabbit_spawn_egg": "Kning-Spawn-Ei",
  "item.minecraft.rabbit_stew": "Kningszupp",
  "item.minecraft.raiser_armor_trim_smithing_template": "Schmiedevorlage",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Aufzieher-Rüstungsbesatz",
  "item.minecraft.ravager_spawn_egg": "Wöderich-Spawn-Ei",
  "item.minecraft.raw_copper": "Rühkoffer",
  "item.minecraft.raw_gold": "Rühjold",
  "item.minecraft.raw_iron": "Rühiese",
  "item.minecraft.recovery_compass": "Bergungskompass",
  "item.minecraft.red_bundle": "Rotes Bündel",
  "item.minecraft.red_dye": "Rude Färv",
  "item.minecraft.red_harness": "Rotes Geschirr",
  "item.minecraft.redstone": "Redstone-Stöbb",
  "item.minecraft.resin_brick": "Harzziegel",
  "item.minecraft.resin_clump": "Harzklumpen",
  "item.minecraft.rib_armor_trim_smithing_template": "Schmiedevorlage",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Rippen-Rüstungsbesatz",
  "item.minecraft.rotten_flesh": "Ömjejange Fleisch",
  "item.minecraft.saddle": "Saddel",
  "item.minecraft.salmon": "Rühe Lachs",
  "item.minecraft.salmon_bucket": "Lachsemmer",
  "item.minecraft.salmon_spawn_egg": "Lachs-Spawn-Ei",
  "item.minecraft.scrape_pottery_sherd": "Abschabe-Töpferscherbe",
  "item.minecraft.scute": "Hornschild",
  "item.minecraft.sentry_armor_trim_smithing_template": "Schmiedevorlage",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Wachen-Rüstungsbesatz",
  "item.minecraft.shaper_armor_trim_smithing_template": "Schmiedevorlage",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Gestalter-Rüstungsbesatz",
  "item.minecraft.sheaf_pottery_shard": "Garben-Töpferscherbe",
  "item.minecraft.sheaf_pottery_sherd": "Garben-Töpferscherbe",
  "item.minecraft.shears": "Schier",
  "item.minecraft.sheep_spawn_egg": "Schof-Spawn-Ei",
  "item.minecraft.shelter_pottery_shard": "Zufluchts-Töpferscherbe",
  "item.minecraft.shelter_pottery_sherd": "Zufluchts-Töpferscherbe",
  "item.minecraft.shield": "Scheld",
  "item.minecraft.shield.black": "Schwatze Scheld",
  "item.minecraft.shield.blue": "Blaue Scheld",
  "item.minecraft.shield.brown": "Brunge Scheld",
  "item.minecraft.shield.cyan": "Blaujröne Scheld",
  "item.minecraft.shield.gray": "Jraue Scheld",
  "item.minecraft.shield.green": "Jröne Scheld",
  "item.minecraft.shield.light_blue": "Hellblaue Scheld",
  "item.minecraft.shield.light_gray": "Helljraue Scheld",
  "item.minecraft.shield.lime": "Helljröne Scheld",
  "item.minecraft.shield.magenta": "Majenta Scheld",
  "item.minecraft.shield.orange": "Orangsche Scheld",
  "item.minecraft.shield.pink": "Rusa Scheld",
  "item.minecraft.shield.purple": "Vijelette Scheld",
  "item.minecraft.shield.red": "Rude Scheld",
  "item.minecraft.shield.white": "Wieße Scheld",
  "item.minecraft.shield.yellow": "Jäle Scheld",
  "item.minecraft.shulker_shell": "Shulker-Schal",
  "item.minecraft.shulker_spawn_egg": "Shulker-Spawn-Ei",
  "item.minecraft.sign": "Scheld",
  "item.minecraft.silence_armor_trim_smithing_template": "Schmiedevorlage",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Stille-Rüstungsbesatz",
  "item.minecraft.silverfish_spawn_egg": "Selverfeschje-Spawn-Ei",
  "item.minecraft.skeleton_horse_spawn_egg": "Pädsjereppe-Spawn-Ei",
  "item.minecraft.skeleton_spawn_egg": "Jereppe-Spawn-Ei",
  "item.minecraft.skull_banner_pattern": "Fahnevörlach",
  "item.minecraft.skull_banner_pattern.desc": "Dudekopp",
  "item.minecraft.skull_banner_pattern.new": "Schädel-Bannervorlage",
  "item.minecraft.skull_pottery_shard": "Totenkopf-Töpferscherbe",
  "item.minecraft.skull_pottery_sherd": "Totenkopf-Töpferscherbe",
  "item.minecraft.slime_ball": "Schliemball",
  "item.minecraft.slime_spawn_egg": "Schliem-Spawn-Ei",
  "item.minecraft.smithing_template": "Schmiedevorlage",
  "item.minecraft.smithing_template.applies_to": "Anwendbar auf:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Barren oder Kristall hinzufügen",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Rüstung",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Rüstungsteil hinzufügen",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Barren & Kristalle",
  "item.minecraft.smithing_template.ingredients": "Werkstoffe:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Netheritbarren hinzufügen",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Diamantausrüstung",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Rüstungsteil, Werkzeug oder Schwert aus Diamant hinzufügen",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Netheritbarren",
  "item.minecraft.smithing_template.upgrade": "Aufwertung: ",
  "item.minecraft.sniffer_spawn_egg": "Schnüffler-Spawn-Ei",
  "item.minecraft.snort_pottery_shard": "Schnaub-Töpferscherbe",
  "item.minecraft.snort_pottery_sherd": "Schnaub-Töpferscherbe",
  "item.minecraft.snout_armor_trim_smithing_template": "Schmiedevorlage",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Schnauzen-Rüstungsbesatz",
  "item.minecraft.snow_golem_spawn_egg": "Schneegolem-Spawn-Ei",
  "item.minecraft.snowball": "Schnieball",
  "item.minecraft.spectral_arrow": "Spektralpiel",
  "item.minecraft.spider_eye": "Spenneauch",
  "item.minecraft.spider_spawn_egg": "Spenne-Spawn-Ei",
  "item.minecraft.spire_armor_trim_smithing_template": "Schmiedevorlage",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Turmspitzen-Rüstungsbesatz",
  "item.minecraft.splash_potion": "Werpdrank",
  "item.minecraft.splash_potion.effect.awkward": "Komische Werpdrank",
  "item.minecraft.splash_potion.effect.empty": "Nit braubare Werpdrank",
  "item.minecraft.splash_potion.effect.fire_resistance": "Förschotzwerpdrank",
  "item.minecraft.splash_potion.effect.harming": "Kapottwerpdrank",
  "item.minecraft.splash_potion.effect.healing": "Heilungswerpdrank",
  "item.minecraft.splash_potion.effect.infested": "Wurftrank des Befalls",
  "item.minecraft.splash_potion.effect.invisibility": "Onsechbarkeetswerpdrank",
  "item.minecraft.splash_potion.effect.leaping": "Höppkraffwerpdrank",
  "item.minecraft.splash_potion.effect.levitation": "Schwevvwerpdrank",
  "item.minecraft.splash_potion.effect.luck": "Jlöckswerpdrank",
  "item.minecraft.splash_potion.effect.mundane": "Jewöhnliche Werpdrank",
  "item.minecraft.splash_potion.effect.night_vision": "Nachseechswerpdrank",
  "item.minecraft.splash_potion.effect.oozing": "Wurftrank des Schleimens",
  "item.minecraft.splash_potion.effect.poison": "Jeffwerpdrank",
  "item.minecraft.splash_potion.effect.regeneration": "Rejenerazijonswerpdrank",
  "item.minecraft.splash_potion.effect.slow_falling": "Langsamfallwerpdrank",
  "item.minecraft.splash_potion.effect.slowness": "Langsamheetswerpdrank",
  "item.minecraft.splash_potion.effect.strength": "Stärkewerpdrank",
  "item.minecraft.splash_potion.effect.swiftness": "Jeschwindechkeetswerpdrank",
  "item.minecraft.splash_potion.effect.thick": "Deckflößije Werpdrank",
  "item.minecraft.splash_potion.effect.turtle_master": "Scheldkraatewerpdrank",
  "item.minecraft.splash_potion.effect.water": "Werpwasserfläsch",
  "item.minecraft.splash_potion.effect.water_breathing": "Ungerwasserodemswerpdrank",
  "item.minecraft.splash_potion.effect.weakness": "Schwächheetswerpdrank",
  "item.minecraft.splash_potion.effect.weaving": "Wurftrank des Webens",
  "item.minecraft.splash_potion.effect.wind_charged": "Wurftrank der Windladung",
  "item.minecraft.spruce_boat": "Danneholzböötche",
  "item.minecraft.spruce_chest_boat": "Fichtenholztruhenboot",
  "item.minecraft.spyglass": "Fernrohr",
  "item.minecraft.squid_spawn_egg": "Inkfesch-Spawn-Ei",
  "item.minecraft.stick": "Stock",
  "item.minecraft.stone_axe": "Steinax",
  "item.minecraft.stone_hoe": "Steinhau",
  "item.minecraft.stone_pickaxe": "Steinpielhau",
  "item.minecraft.stone_shovel": "Steinschöpp",
  "item.minecraft.stone_spear": "Steinspeer",
  "item.minecraft.stone_sword": "Steinschwäät",
  "item.minecraft.stray_spawn_egg": "Vajabund-Spawn-Ei",
  "item.minecraft.strider_spawn_egg": "Schreiter-Spawn-Ei",
  "item.minecraft.string": "Fäddem",
  "item.minecraft.sugar": "Zucker",
  "item.minecraft.suspicious_stew": "Zuspekte Zupp",
  "item.minecraft.sweet_berries": "Sößbere",
  "item.minecraft.tadpole_bucket": "Kaulquappeneimer",
  "item.minecraft.tadpole_spawn_egg": "Kaulquappen-Spawn-Ei",
  "item.minecraft.tide_armor_trim_smithing_template": "Schmiedevorlage",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Gezeiten-Rüstungsbesatz",
  "item.minecraft.tipped_arrow": "Jedränkte Piel",
  "item.minecraft.tipped_arrow.effect.awkward": "Jedränkte Piel",
  "item.minecraft.tipped_arrow.effect.empty": "Nit herstellbare jedränkte Piel",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Förschotzpiel",
  "item.minecraft.tipped_arrow.effect.harming": "Kapottpiel",
  "item.minecraft.tipped_arrow.effect.healing": "Heilungspiel",
  "item.minecraft.tipped_arrow.effect.infested": "Pfeil des Befalls",
  "item.minecraft.tipped_arrow.effect.invisibility": "Onsechbarkeetspiel",
  "item.minecraft.tipped_arrow.effect.leaping": "Höppkraffpiel",
  "item.minecraft.tipped_arrow.effect.levitation": "Schwevvpiel",
  "item.minecraft.tipped_arrow.effect.luck": "Jlöckspiel",
  "item.minecraft.tipped_arrow.effect.mundane": "Jedränkte Piel",
  "item.minecraft.tipped_arrow.effect.night_vision": "Nachseechspiel",
  "item.minecraft.tipped_arrow.effect.oozing": "Pfeil des Schleimens",
  "item.minecraft.tipped_arrow.effect.poison": "Jeffpiel",
  "item.minecraft.tipped_arrow.effect.regeneration": "Rejenerazijonspiel",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Langsamfallpiel",
  "item.minecraft.tipped_arrow.effect.slowness": "Langsamheetspiel",
  "item.minecraft.tipped_arrow.effect.strength": "Stärkepiel",
  "item.minecraft.tipped_arrow.effect.swiftness": "Jeschwindechkeetspiel",
  "item.minecraft.tipped_arrow.effect.thick": "Jedränkte Piel",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Scheldkraatepiel",
  "item.minecraft.tipped_arrow.effect.water": "Nasse Piel",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Ungerwasserodemspiel",
  "item.minecraft.tipped_arrow.effect.weakness": "Schwächheetspiel",
  "item.minecraft.tipped_arrow.effect.weaving": "Pfeil des Webens",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Pfeil der Windladung",
  "item.minecraft.tnt_minecart": "Sprengkar",
  "item.minecraft.torchflower_seeds": "Fackelliliensamen",
  "item.minecraft.totem_of_undying": "Totem vun dä Onstervlichkeit",
  "item.minecraft.trader_llama_spawn_egg": "Kriemerlama-Spawn-Ei",
  "item.minecraft.trial_key": "Prüfungsschlüssel",
  "item.minecraft.trident": "Dreizack",
  "item.minecraft.tropical_fish": "Tropefesch",
  "item.minecraft.tropical_fish_bucket": "Tropefeschemmer",
  "item.minecraft.tropical_fish_spawn_egg": "Tropefesch-Spawn-Ei",
  "item.minecraft.turtle_helmet": "Scheldkraatepanzer",
  "item.minecraft.turtle_scute": "Schildkröten-Hornschild",
  "item.minecraft.turtle_spawn_egg": "Scheldkraate-Spawn-Ei",
  "item.minecraft.vex_armor_trim_smithing_template": "Schmiedevorlage",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Plagegeister-Rüstungsbesatz",
  "item.minecraft.vex_spawn_egg": "Vexeerer-Spawn-Ei",
  "item.minecraft.villager_spawn_egg": "Enwonner-Spawn-Ei",
  "item.minecraft.vindicator_spawn_egg": "Deener-Spawn-Ei",
  "item.minecraft.wandering_trader_spawn_egg": "Kriemer-Spawn-Ei",
  "item.minecraft.ward_armor_trim_smithing_template": "Schmiedevorlage",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Warthof-Rüstungsbesatz",
  "item.minecraft.warden_spawn_egg": "Wärter-Spawn-Ei",
  "item.minecraft.warped_fungus_on_a_stick": "Jeckepelz am Stock",
  "item.minecraft.water_bucket": "Wasseremmer",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Schmiedevorlage",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Wegfinder-Rüstungsbesatz",
  "item.minecraft.wheat": "Weizze",
  "item.minecraft.wheat_seeds": "Weizesome",
  "item.minecraft.white_bundle": "Weißes Bündel",
  "item.minecraft.white_dye": "Wieße Färv",
  "item.minecraft.white_harness": "Weißes Geschirr",
  "item.minecraft.wild_armor_trim_smithing_template": "Schmiedevorlage",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Wildnis-Rüstungsbesatz",
  "item.minecraft.wind_charge": "Windkugel",
  "item.minecraft.witch_spawn_egg": "Hexe-Spawn-Ei",
  "item.minecraft.wither_skeleton_spawn_egg": "Witherjerepp-Spawn-Ei",
  "item.minecraft.wither_spawn_egg": "Wither-Spawn-Ei",
  "item.minecraft.wolf_armor": "Wolfspanzer",
  "item.minecraft.wolf_spawn_egg": "Wolf-Spawn-Ei",
  "item.minecraft.wooden_axe": "Holzax",
  "item.minecraft.wooden_hoe": "Holzhau",
  "item.minecraft.wooden_pickaxe": "Holzpielhau",
  "item.minecraft.wooden_shovel": "Holzschöpp",
  "item.minecraft.wooden_spear": "Holzspeer",
  "item.minecraft.wooden_sword": "Holzschwäät",
  "item.minecraft.writable_book": "Boch un Fädder",
  "item.minecraft.written_book": "Jeschrivve Boch",
  "item.minecraft.yellow_bundle": "Gelbes Bündel",
  "item.minecraft.yellow_dye": "Jäl Färv",
  "item.minecraft.yellow_harness": "Gelbes Geschirr",
  "item.minecraft.zoglin_spawn_egg": "Zoglin-Spawn-Ei",
  "item.minecraft.zombie_horse_spawn_egg": "Zombipäd-Spawn-Ei",
  "item.minecraft.zombie_nautilus_spawn_egg": "Zombienautilus-Spawn-Ei",
  "item.minecraft.zombie_spawn_egg": "Zombi-Spawn-Ei",
  "item.minecraft.zombie_villager_spawn_egg": "Zombi-Enwonner-Spawn-Ei",
  "item.minecraft.zombified_piglin_spawn_egg": "Zombifizeete-Piglin-Spawn-Ei"
}
export const ksh = items; 
